// fetch polyfill https://github.com/developit/unfetch
self.fetch || (self.fetch = function (e, n) { return n = n || {}, new Promise(function (t, r) { var s = new XMLHttpRequest; for (var o in s.open(n.method || "get", e, !0), n.headers) s.setRequestHeader(o, n.headers[o]); function u() { var e, n = [], t = [], r = {}; return s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (s, o, u) { n.push(o = o.toLowerCase()), t.push([o, u]), r[o] = (e = r[o]) ? e + "," + u : u }), { ok: 2 == (s.status / 100 | 0), status: s.status, statusText: s.statusText, url: s.responseURL, clone: u, text: function () { return Promise.resolve(s.responseText) }, json: function () { return Promise.resolve(s.responseText).then(JSON.parse) }, blob: function () { return Promise.resolve(new Blob([s.response])) }, headers: { keys: function () { return n }, entries: function () { return t }, get: function (e) { return r[e.toLowerCase()] }, has: function (e) { return e.toLowerCase() in r } } } } s.withCredentials = "include" == n.credentials, s.onload = function () { t(u()) }, s.onerror = r, s.send(n.body || null) }) });

/*

 EFFEKT/ENERGI LEVERANSER
 ------------------------

 This is a auto-updating visualisation of the energi production/consumption in GBG.
 It can be used to show all available sources (with tabs to switch between them),
 or to show just one source with no tabs, no navigation, no text (eg, the Solevi page).

 QUICK SET-UP:
 ------------

 To run, you need two scripts, one css (should be in head, but can be in body
    <script type="text/javascript" src="/PATHTO/d3.min.js"></script> 
    <script type="text/javascript" src="/PATHTO/effektleveranser.min.js"></script>
    <link rel="stylesheet" href="/PATHTO/effektleveranser.css" />
 NOTE: the d3 version used here is v4. No other libs/frameworks are required.

 The standard GE site shared CSS is also required (mainly for typography and the 
 the animation keyframes, which are used to fade-in key components).

    <link href="https://www.goteborgenergi.se/GoteborgEnergi/Web20/static/shared.css" rel="stylesheet">

 Lastly you need some markup in the page. It can be configured in the script below, but
 by default is looking for a standard image component in an xxl section (eg, below). 
 It will hijack the first one it comes across on the page.

  <figure class="Ge-Image-Inner Ge-Section-Inner Ge-Section-Inner--xxl">
    <div class="Ge-Image-Frame lazyload-strut">
      <img alt data-src="BLAHBLAH" data-srcset="BLAHBLAH" width="1100" height="698" class="Ge-Image-Img lazyload" />
      <noscript><img src="/DynamixPublic/Images/df0cd683eb287c34133c50d21c6301fff3f0afec" class="Ge-Image-Img Ge-Image-Fallback" /></noscript>
    </div>
  </figure>

 Optionally, you can an add config as datatypes attr to an element. It's only purpose is
 to provide any set-up info to the script, and is often on a hidden element (below), but  
 the params can be on any element in the page really. If you don't have it, the full 
 effektleveranser will spin up with the hard coded data url, and Solenergi as the default.

  <div data-js-effektleveranser data-text-hide data-tab-hide data-cals-hide data-measure-api="https://www.goteborgenergi.se/GeneralApi?command=Measurements" style="display:none"></div>

HOW THIS WORKS
______________

The script was originally to be included on a standard goteborgenergi.se dynamix page, but hosted on a seperate server. The script then hijacked a standard image component on that page, replacing it with the visual.

Since then, the remote server part has been in integrated into the main site, but the worklow of it being a JS layer on top of (and hijacking) a standard dynamix page remains.

SET-UP CONFIG
-------------
By adding some data-type attributes in the page HTML, you can alter the config of the script
without haveing to touch any of the script itself. Here are the following optional data-types:
- data-js-effektleveranser 
  If you add any config settings, that need to be adde to one element, 
  and it has to have this data-type (as a way of identifying it).
- data-measure-api="" 
  The url to the data API that feeds the visualisation
- data-allow-origin-id="" 
  CORS setting to allow handshake with remote JS. Talk to Stefan to see if it still works.
- data-tab-default="solevi"
  Sets the source that is shown on page load, by it's key in the settings in the JS 
  (eg, "fv" will show the Fjärrevärme data on page load)
- data-text-hide 
  if present, text column on left (dscribig each energu source) is hidden
- data-tab-hide
  if present, tabs for each source are hidden (and their data is not retrieved)


NOTES
-----

- In daily view, clicking left/right arrows will go back/forward a day
- On browsers that support full screen (not IE, not iPhone), holding down the "SHIFT"
  key will reveal a "full screen" button in the bottom left. Tap this to take over the screen.
- Once in full screen mode (described in previous point), click "H" and all buttons and tabs
  will also disappear (only while in full screen).
- each source can be configured to tell it what units the incoming data is (kW/MW)
- max output can be set, so that we can show how effective a source is (eg, "solenergi is 
  currently 79% of max"). But this is optional, and if set to 0, the max will not be shown.
- most data sources in the config below are simple, eg solenergi is 96988. But some sources 
  are aggregated from several sources, eg Kräftvärme, which aggregates three measure ids.
  In this case the measure id is set as '74645,MW,16800,MW,60434,MW', listing the id of 
  each measure id, along with the unit of the data it returns. The script sorts it all out.
  There is a max of three sources in an aggregate.
- In this "aggregate feed" case above, you can detail each measure id, so that pop-overs and
  colours can be configured properly. see the sourcesMeta variable below. Each source has a 
  CSS class (for colouring the graph segment), and two names "Type" and "suffix". This is 
  because of a tricky brief. With Kräftvärme, below the title we wanted a key with two 
  items ("Fossil" and "Förnybar"). But in the graph, we wanted to be able to tell the difference
  between the two Fossil sources. Hence, in the config, two of the sources are labelled "Fossil",
  but with the different suffixes, they have two rollover titles in the graph "Fossil 1" & 
  "Fossil 2".
- the data interval can be set source-by-source, 'all' shows a graph segment every 10 minutes
  (144 segnments in a day), 'hour' shows a graph segment for every hour (eg in el, 24 segments)
- most sources show the clock as 24 hour. Solenergi will show it as sun-up/down time
  which changes through the year (the weekly table of settings is in this script below)

TROUBLESHOOTING
---------------
- The data is blank?
  Almost certainly a data feed issue. If it looks ok-ish but has drop-outs, that's not unusual.
  If it's blank, that's also not unusual but needs flagging up. But first check that the console
  isn't showing up any unfetchable URLs for the data API. Could be the measureId o fthe source 
  has changed, so when you query it, quote the measureId of the feed that you're missing (it'll
  be listed in the config JSON below).
- When I click on X tab, the numbers don't change. It just keeps the numbers of the previous
  tab and changes the colour?
  This is a specific problem with a data feed. If a data feed is "down", it still returns an array 
  of zeros. But when this problem occurs, it's returning an empty array. You can check in the
  console network - look at the response from GeneralApi?command... requests, and see if the
  the "measurements" value is an empty array. Then report it as a problem to Per with that 
  measurement id.
- The fonts look wrong?
  The shared.css is probably missing, as it holds the standard GE font definitions. If it's
  the number font that looks weird (chunky on windows, courier-like on mac), it's the google
  font in imported in the effektleveranser.css that's gone wrong - so dtart looking there.
- The center hub is blank?
  The shared.css is probably missing. The hub appears on a keyframe animation, and those keyframes
  are in the shared.css file. No css, no animation, no hub.
- I want to change the colour of X?
  It'll be in the CSS file.
- I want to change the text of X?
  It'll be in the template in this file, see below.

## DATA API AND CORS

The data API endpoint returns JSON mesurements for a single measurementId. It is CORS 
protected and so only returns data to a JS script running on https://www.goteborgenergi.se

If you need to test anything locally, here's a horribly hacky way of doing it without 
uploading things to Goteborgenergi.se:
- go to https://www.goteborgenergi.se/effektleveranser-beta (which doesn't work because the 
  urls are pointing to the wrong server. But it's a useful skeleton to use here).
- In devtools, change/delete the DIV that holds the config (it has a data type 
  `data-js-ge-solevi`)
- Change the link for the effektleveranser CSS file in the page to 
  `/Files/Webb20/Effektleveranser/effektleveranser.css`
- Copy https://cdnjs.cloudflare.com/ajax/libs/d3/4.13.0/d3.min.js and paste it into the 
  beta page console. This gets D3 running.
- Copy the effektleveranser script that you are working on locally and paste it into the 
  beta page console.
- The effektleveranser (or Solevi visualisation) should now work.

*/

const effektDashboard = function () {

    // no d3? no dice.
    if (typeof d3 === 'undefined') {
        console.error('D3 not in page, or not included BEFORE the effektleveranser script, can not start up effektleveranser');
        return;
    }

    /*
     DEFAULT PARAMS
     */
    let powerApiUrl = '/GeneralApi?command=Measurements';   // data API url
    let powerApiCors = null;     // data API CORS value. Used to securely handshake with API within a script.
    let hideText = false;
    let hideTabs = false;
    let hideCals = false;

    let mode = 'sol';
    let zoom = false; // false is day view, true is calendar view
    let maxNu = 'nu';
    let longMode = '30days';// 'year'

    const tabUpdate = 60; // seconds between updating tab data
    const dayUpdate = 60; // seconds between updating daily data

    const sunUpDown = {         // list of sunrise(sunset times by week number). Yes, the clock gets longer the closer to summer we get add new ones by copying across from https://api.sunrise-sunset.org/json?lat=57.7089&lng=11.9746&date=2019-02-11&formatted=0. This *should* work over multiple years with negligable errors, not just 2019 - we've just using this year's actual data.
        1: ['2018-12-31T07:55:16', '2018-12-31T14:35:18'],
        2: ['2019-01-07T07:51:28', '2019-01-07T14:45:27'],
        3: ['2019-01-14T07:44:16', '2019-01-14T14:58:11'],
        4: ['2019-01-21T07:34:09', '2019-01-21T15:12:45'],
        5: ['2019-01-28T07:21:38', '2019-01-28T15:28:29'],
        6: ['2019-02-04T07:07:10', '2019-02-04T15:44:51'],
        7: ['2019-02-11T06:51:11', '2019-02-11T16:01:25'],
        8: ['2019-02-18T06:34:01', '2019-02-18T16:17:56'],
        9: ['2019-02-25T06:15:57', '2019-02-25T16:34:14'],
        10: ['2019-03-04T05:57:14', '2019-03-04T16:50:16'],
        11: ['2019-03-11T05:38:03', '2019-03-11T17:06:03'],
        12: ['2019-03-18T05:18:35', '2019-03-18T17:21:36'],
        13: ['2019-03-25T04:58:59', '2019-03-25T17:37:02'],
        14: ['2019-04-01T04:39:25', '2019-04-01T17:52:23'],
        15: ['2019-04-08T04:20:02', '2019-04-08T18:07:45'],
        16: ['2019-04-15T04:01:00', '2019-04-15T18:23:11'],
        17: ['2019-04-22T03:42:29', '2019-04-22T18:38:39'],
        18: ['2019-04-29T03:24:44', '2019-04-29T18:54:06'],
        19: ['2019-05-06T03:08:00', '2019-05-06T19:09:24'],
        20: ['2019-05-13T02:52:37', '2019-05-13T19:24:16'],
        21: ['2019-05-20T02:38:56', '2019-05-20T19:38:21'],
        22: ['2019-05-27T02:27:26', '2019-05-27T19:51:08'],
        23: ['2019-06-03T02:18:35', '2019-06-03T20:02:00'],
        24: ['2019-06-10T02:12:52', '2019-06-10T20:10:19'],
        25: ['2019-06-17T02:10:39', '2019-06-17T20:15:29'],
        26: ['2019-06-24T02:12:04', '2019-06-24T20:17:06'],
        27: ['2019-07-01T02:17:00', '2019-07-01T20:15:02'],
        28: ['2019-07-08T02:25:02', '2019-07-08T20:09:26'],
        29: ['2019-07-15T02:35:34', '2019-07-15T20:00:39'],
        30: ['2019-07-22T02:47:58', '2019-07-22T19:49:12'],
        31: ['2019-07-29T03:01:37', '2019-07-29T19:35:33'],
        32: ['2019-08-05T03:16:01', '2019-08-05T19:20:10'],
        33: ['2019-08-12T03:30:48', '2019-08-12T19:03:25'],
        34: ['2019-08-19T03:45:43', '2019-08-19T18:45:38'],
        35: ['2019-08-26T04:00:37', '2019-08-26T18:27:05'],
        36: ['2019-09-02T04:15:27', '2019-09-02T18:07:59'],
        37: ['2019-09-09T04:30:11', '2019-09-09T17:48:31'],
        38: ['2019-09-16T04:44:54', '2019-09-16T17:28:51'],
        39: ['2019-09-23T04:59:39', '2019-09-23T17:09:08'],
        40: ['2019-09-30T05:14:31', '2019-09-30T16:49:30'],
        41: ['2019-10-07T05:29:36', '2019-10-07T16:30:08'],
        42: ['2019-10-14T05:44:57', '2019-10-14T16:11:10'],
        43: ['2019-10-21T06:00:35', '2019-10-21T15:52:47'],
        44: ['2019-10-28T06:16:30', '2019-10-28T15:35:15'],
        45: ['2019-11-04T06:32:33', '2019-11-04T15:18:47'],
        46: ['2019-11-11T06:48:32', '2019-11-11T15:03:44'],
        47: ['2019-11-18T07:04:07', '2019-11-18T14:50:29'],
        48: ['2019-11-25T07:18:46', '2019-11-25T14:39:30'],
        49: ['2019-12-02T07:31:52', '2019-12-02T14:31:16'],
        50: ['2019-12-09T07:42:43', '2019-12-09T14:26:18'],
        51: ['2019-12-16T07:50:36', '2019-12-16T14:24:59'],
        52: ['2019-12-23T07:54:58', '2019-12-23T14:27:32'],
        53: ['2019-12-30T07:55:33', '2019-12-30T14:33:49']
    };
    let sunUpHour = 0;        // sunrise hour - reset in initDate()
    let sunUpNudge = 2;        // adjustment to any sun-rise time ( 1 = +1 hour, -1 = -1 hour, etc )
    let sunDownHour = 24;       // sunset hour - reset in initDate()
    let sunDownNudge = 1;        // adjustment to any sun-down time ( 1 = +1 hour, -1 = -1 hour, etc )
    let filterObj = {         // filter object - in
        date: ''
    };
    let currentHour = 0;        // the current hour (in decimal, so 08:30 = 8.5)
    let currentPerc = 0;        // the current percentage of the sun/up down time (to the nearest 10 minutes to match readings). eg is sun-up is 07:00 and sun-down 17:00, the time of 17:00 is a currentPerc = 1, 11:30 = 0.45. Used to quickly size clock items.

    let tickDate = new Date(); // this instant - incremented in the ticker loop
    let tickSubs = []        // list of subscriptions to check on each tick
    let tickSubsLookup = {}        // list of tickSubs keys for quick updating without looping them each time

    let dataInterval = 'all';    // the interval we check for. 'all' is 10 minutes, plus 'hour', 'day', 'last24h', 'current' (the last two don't need a start/end date in the API call)
    let dataDate = null;     // date object of the current date/time being requested. If it's today, it will be the correct hh:mm:ss, otherwise it will be the start of the day , eg new Date( [date]T00:00:00 )
    let dataObj = null;     // the radial graph data object
    let longDataObj = [];       // the long graph data object
    let secondDataObj = [];       // the secondary long graph data object
    let dataSegmentCount = 144;   // the data segment count per day. 144 is default (10 minute measurement slots * 24 hours), set to 24 if the interval is 'hour'
    let dataMaxkW = 0;        // the max kW power generated in the current data set.

    const sweepAngleStart = 225;  // the clock is not a whole circle. It starts bottom left - this is the start angle
    const sweepAngleEnd = 495;  // the clock is not a whole circle. It ends bottom right - this is the end angle (more than 360,  that it draws in the correct direction)

    /*
     OPTIONAL EXTERNAL SET-UP PARAMETERS (and their fallback defaults)
     set-up params can be added as attributes to an element in the page with one of 
     the two below selectors. so, t.ex:

      <div data-js-effektleveranser data-text-hide data-tab-hide data-cals-hide data-measure-api="https://www.goteborgenergi.se/GeneralApi?command=Measurements" style="display:none"></div>
     */
    const configParamsSelector1 = `[data-js-effektleveranser]`;
    const configParamsSelector2 = `[data-js-ge-solevi]`;
    let $configParams = document.querySelector(configParamsSelector1);
    if (!$configParams) {
        $configParams = document.querySelector(configParamsSelector2);
    }
    if ($configParams) {
        powerApiUrl = ($configParams.hasAttribute('data-measure-api') ? $configParams.getAttribute('data-measure-api') : powerApiUrl);
        powerApiCors = ($configParams.hasAttribute('data-allow-origin-id') ? $configParams.getAttribute('data-allow-origin-id') : powerApiCors);
        hideText = $configParams.hasAttribute('data-text-hide'); // hide the text sidebar
        hideTabs = $configParams.hasAttribute('data-tab-hide'); // hide the tags
        hideCals = $configParams.hasAttribute('data-cals-hide'); // hide the calendar nav buttons
        mode = ($configParams.hasAttribute('data-tab-default') ? $configParams.getAttribute('data-tab-default') : mode); // show which source key on page load?
    }

    const utbyId = '103224';
    const soleviId = '96988';
    const soleviMax = 5000;
    const utbyMax = 4500;

    const elId = '75029283';
    const vindId = '1344';
    const vindMax = 50;

    const sources = {
        sol: {
            id: `${soleviId},kW,${utbyId},kW`,
            title: 'Solenergi',
            unitsData: 'kW',
            dataInterval: 'all',
            max: soleviMax + utbyMax,
            maxHide: false,
            inOut: 'producerade',
            toolTips: {
                nu: {
                    number: 'Mängden solenergi producerad hittills i dag',
                    extra1: 'Mängden solenergi vi producerar just nu',
                    extra2: 'Procent av maxproduktion'
                },
                topp: {
                    number: 'Mängden solenergi producerad under hela dagen',
                    extra1: 'Dagens högsta produktion',
                    extra2: 'Dagens högsta produktion i förhållande till maxproduktion'
                },
            },
            firstDate: '2019-02-06',
            secondary: [
                {
                    id: 2755,
                    title: "Solinstrålning",
                    unitsData: 'W/m²',
                    max: 1000
                }
            ]
        },
        solevi: {
            id: soleviId,
            hideTab: true,
            title: 'Solevi',
            unitsData: 'kW',
            dataInterval: 'all',
            max: soleviMax,
            maxHide: false,
            inOut: 'producerade',
            toolTips: {
                nu: {
                    number: 'Mängden solenergi producerad hittills i dag',
                    extra1: 'Mängden solenergi vi producerar just nu',
                    extra2: 'Procent av maxproduktion'
                },
                topp: {
                    number: 'Mängden solenergi producerad under hela dagen',
                    extra1: 'Dagens högsta produktion',
                    extra2: 'Dagens högsta produktion i förhållande till maxproduktion'
                },
            },
            firstDate: '2019-02-06',
            secondary: [
                {
                    id: 2755,
                    title: "Solinstrålning",
                    unitsData: 'W/m²',
                    max: 1000
                }
            ]
        },
        utby: {
            id: utbyId,
            hideTab: true,
            title: 'Solinavium',
            unitsData: 'kW',
            dataInterval: 'all',
            max: utbyMax,
            maxHide: false,
            inOut: 'producerade',
            toolTips: {
                nu: {
                    number: 'Mängden solenergi producerad hittills i dag',
                    extra1: 'Mängden solenergi vi producerar just nu',
                    extra2: 'Procent av maxproduktion'
                },
                topp: {
                    number: 'Mängden solenergi producerad under hela dagen',
                    extra1: 'Dagens högsta produktion',
                    extra2: 'Dagens högsta produktion i förhållande till maxproduktion'
                },
            },
            firstDate: '2019-02-06',
            secondary: [
                {
                    id: 2755,
                    title: "Solinstrålning",
                    unitsData: 'W/m²',
                    max: 1000
                }
            ]
        },
        vind: {
            id: vindId,
            title: 'Vindkraft',
            unitsData: 'MW',
            dataInterval: 'all',
            max: vindMax,
            maxHide: false,
            inOut: 'producerade',
            toolTips: {
                nu: {
                    number: 'Mängden vindkraft producerad hittills i dag',
                    extra1: 'Mängden vindkraft vi producerar just nu',
                    extra2: 'Procent av maxproduktion'
                },
                topp: {
                    number: 'Mängden vindkraft producerad under hela dagen',
                    extra1: 'Dagens högsta produktion',
                    extra2: 'Dagens högsta produktion i förhållande till maxproduktion'
                },
            },
            firstDate: '2018-01-01',
            secondary: []
        },
        fv: {
            id: 1000,
            title: 'Fjärrvärme',
            unitsData: 'MW',
            dataInterval: 'all',
            max: 0,
            maxHide: true,
            inOut: 'producerade',
            toolTips: {
                nu: {
                    number: 'Energi producerad hittills i dag',
                    extra1: 'Mängden energi vi producerar just nu'
                },
                topp: {
                    number: 'Mängden energi producerad under hela dagen',
                    extra1: 'Dagens högsta produktion'
                },
            },
            firstDate: '2018-01-01',
            secondary: [
                {
                    id: 1010,
                    title: "Temperatur",
                    unitsData: '°C',
                    max: 30
                }
            ]
        },
        kv: {
            id: '74645,MW,16800,MW,60434,MW',
            title: 'Kraftvärme (el)',
            unitsData: 'kW',
            dataInterval: 'all',
            max: 26000,
            maxHide: true,
            inOut: 'producerade',
            toolTips: {
                nu: {
                    number: 'Energi producerad hittills i dag',
                    extra1: 'Mängden energi vi producerar just nu'
                },
                topp: {
                    number: 'Mängden energi producerad under hela dagen',
                    extra1: 'Dagens högsta produktion'
                },
            },
            firstDate: '2018-01-01',
            secondary: [
                {
                    id: 1010,
                    title: "Temperatur",
                    unitsData: '°C',
                    max: 30
                }
            ]
        },
        fk: {
            id: 1528,
            title: 'Fjärrkyla',
            unitsData: 'MW',
            dataInterval: 'all',
            max: 0,
            maxHide: true,
            inOut: 'producerade',
            toolTips: {
                nu: {
                    number: 'Energi producerad hittills i dag',
                    extra1: 'Mängden energi vi producerar just nu'
                },
                topp: {
                    number: 'Mängden energi producerad under hela dagen',
                    extra1: 'Dagens högsta produktion'
                },
            },
            firstDate: '2018-01-01',
            secondary: [
                {
                    id: 1010,
                    title: "Temperatur",
                    unitsData: '°C',
                    max: 30
                }
            ]
        },
        gas: {
            id: '1757,kW,1701,MW',
            title: 'Gas',
            unitsData: 'kW',
            dataInterval: 'all',
            max: 0,
            maxHide: true,
            inOut: 'levererade',
            toolTips: {
                nu: {
                    number: 'Energi levererade hittills i dag',
                    extra1: 'Energi levererade just nu',
                },
                topp: {
                    number: 'Mängden energi levererade under hela dagen',
                    extra1: 'Dagens högsta uppmätta leverans',
                },
            },
            firstDate: '2018-01-01',
            secondary: []
        },
        el: {
            id: elId,
            title: 'El',
            unitsData: 'MW',
            dataInterval: 'hour',
            max: 0,
            maxHide: true,
            inOut: 'levererade',
            toolTips: {
                nu: {
                    number: 'Energi levererade hittills i dag',
                    extra1: 'Energi levererade just nu',
                },
                topp: {
                    number: 'Mängden energi levererade under hela dagen',
                    extra1: 'Dagens högsta uppmätta leverans',
                },
            },
            firstDate: '2018-01-01',
            secondary: [
                {
                    id: 1010,
                    title: "Temperatur",
                    unitsData: '°C',
                    max: 30
                }
            ]
        }
    };

    const sourcesMeta = {
        '60434': {
            type: 'Fossil',
            suffix: '2',
            class: 'kv'
        },
        '74645': {
            type: 'Förnybar',
            suffix: '',
            class: 'kvGreen'
        },
        '16800': {
            type: 'Fossil',
            suffix: '1',
            class: 'kv'
        },
        [utbyId]: {
            type: 'Solinavium',
            suffix: '',
            class: 'solUtby',
            max: utbyMax
        },
        [soleviId]: {
            type: 'Solevi',
            suffix: '',
            class: '',
            max: soleviMax
        },

        //  '1757' : {
        //      type : 'Biogas',
        //      suffix : '',
        //      class : 'gasGreen'
        //  },
        // '1701' : {
        //     type : 'Naturgas',
        //     suffix : '',
        // }
    }

    let defaultMeasureId = sources[mode].id; // power data API measurement point ID. The park has several measurement IDs - eg one for current power and one for UV radiation levels (set by reading a data-type off a hidden element in the page)


    // SET UP CANVAS FOR HJACK
    const $canvas = document.querySelector('.Ge-Image-Inner.Ge-Section-Inner--xxl'); // when used in a XXL image
    // no canvas found, no dashboard
    if (!$canvas) {
        console.error('EFFEKTLEVERANSER UNABLE TO LOAD - CAN\'T FIND EL IN PAGE TO HIJACK')
        return;
    }
    const $inner = $canvas.querySelector('.Ge-Image-Frame'); // when used in a XXL image

    let title = sources[mode].title;
    let unitsData = sources[mode].unitsData;
    let firstDate = sources[mode].firstDate;
    let unitsHub = unitsData;
    let optimumMax = sources[mode].max;     // the predicted max power of the park - 5MW
    let optimumMaxHide = sources[mode].maxHide;     // the predicted max power of the park - 5MW
    let inOut = sources[mode].inOut;

    // SVG elements

    let $svg1Clock = null;
    let $svg1ClockGraph = null;
    let $svg1LongGraph = null;
    let $svg1LongGraphAxis = null;
    let $svg1LongGraphBack = null;
    let $svg1LongGraphLine1 = null;
    let $svg1LongGraphLine1Title = null;
    let $svg1LongGraphLine2 = null;
    let $svg1LongGraphLine2Title = null;

    let $hudHubValue1 = null;
    let $hudHubValue2 = null;
    let $hudHubValue3 = null;
    let $hudHubExtra1 = null;
    let $hudHubExtra2 = null;
    let $hudLoading1 = null;
    let $hudLoading2 = null;

    const radius05 = 280;      // hub radius
    const radius08 = 290;      // hub white ring radius
    const radius09 = 290;      // loading ring radius
    const radius10 = 318;      // sweep/radial graph/chapter ring inner radius
    const radius20 = 360;      // baseline of title (at bottom)
    const radius30 = 410;      // chapter ring indices inner radius
    const radius40 = 430;      // sweep/radial graph/chapter ring outer radius
    const radius50 = 520;      // button text radius

    const graphWidth = 960;      // long-term graph, width
    const graphHeight = 550;      // long-term graph, height
    const graph1Top = 180;      // long-term graph - main, top
    const graph1Bot = 425       // long-term graph - main, bottom
    const graph2Top = 40;      // long-term graph - main, bottom
    const graph2Bot = 120;      // long-term graph - main, bottom
    const graph3Top = 40;       // long-term graph - main, bottom
    const graph3Bot = 120;      // long-term graph - main, bottom

    let touchEvents = {};

    let titleOffset = (isIE() ? '-60' : '0');

    let template = '';

    if (!hideTabs) {
        template = `
    <section class="hud__tabs">
        <div class="hud__tabs__inner">
            <button class="hud__tab hud--mode-sol" data-js-toggle data-mode="sol" data-id="${sources.sol.id}" data-title="${sources.sol.title}" data-units="${sources.sol.unitsData}" data-firstdate="${sources.sol.firstDate}" data-max="${sources.sol.max}" data-max-hide="${sources.sol.maxHide}" data-in-out="${sources.sol.inOut}">
                <div class="hud__tab__name" aria-label="${sources.sol.title}">Sol<span class="hud__tab__name--lg">energi</span></div>
                <div class="hud__tab__kw"><span data-js-tab-totals data-tab="sol">&#160;</span></div>
                <span class="hud__tab__graph" data-js-tab-graph="sol"></span>
            </button>
            <button class="hud__tab hud--mode-vind" data-js-toggle data-mode="vind" data-id="${sources.vind.id}" data-title="${sources.vind.title}" data-units="${sources.vind.unitsData}" data-firstdate="${sources.vind.firstDate}" data-max="${sources.vind.max}" data-max-hide="${sources.vind.maxHide}" data-in-out="${sources.vind.inOut}">
                <div class="hud__tab__name" aria-label="${sources.vind.title}">Vind<span class="hud__tab__name--lg">kraft</span></div>
                <div class="hud__tab__kw"><span data-js-tab-totals data-tab="vind">&#160;</span></div>
                <span class="hud__tab__graph" data-js-tab-graph="vind"></span>
            </button>
            <button class="hud__tab hud--mode-fv" data-js-toggle data-mode="fv" data-id="${sources.fv.id}" data-title="${sources.fv.title}" data-units="${sources.fv.unitsData}" data-firstdate="${sources.fv.firstDate}" data-max="${sources.fv.max}" data-max-hide="${sources.fv.maxHide}" data-in-out="${sources.fv.inOut}">
                <div class="hud__tab__name" aria-label="${sources.fv.title}"><span class="hud__tab__name--lg">Fjärrvärme</span><span class="hud__tab__name--xs" aria-hidden="true">F/vär</span></div>
                <div class="hud__tab__kw"><span data-js-tab-totals data-tab="fv">&#160;</span></div>
                <span class="hud__tab__graph" data-js-tab-graph="fv"></span>
            </button>
            <button class="hud__tab hud--mode-fk" data-js-toggle data-mode="fk" data-id="${sources.fk.id}" data-title="${sources.fk.title}" data-units="${sources.fk.unitsData}" data-firstdate="${sources.fk.firstDate}" data-max="${sources.fk.max}" data-max-hide="${sources.fk.maxHide}" data-in-out="${sources.fk.inOut}">
                <div class="hud__tab__name" aria-label="${sources.fk.title}"><span class="hud__tab__name--lg">Fjärrkyla</span><span class="hud__tab__name--xs" aria-hidden="true">F/kyl</span></div>
                <div class="hud__tab__kw"><span data-js-tab-totals data-tab="fk">&#160;</span></div>
                <span class="hud__tab__graph" data-js-tab-graph="fk"></span>
            </button>
            <button class="hud__tab hud--mode-kv" data-js-toggle data-mode="kv" data-id="${sources.kv.id}" data-title="${sources.kv.title}" data-units="${sources.kv.unitsData}" data-firstdate="${sources.kv.firstDate}" data-max="${sources.kv.max}" data-max-hide="${sources.kv.maxHide}" data-in-out="${sources.kv.inOut}">
                <div class="hud__tab__name" aria-label="${sources.kv.title}"><span class="hud__tab__name--lg">Kraftvärme</span><span class="hud__tab__name--xs" aria-hidden="true">K/vär</span></div>
                <div class="hud__tab__kw"><span data-js-tab-totals data-tab="kv">&#160;</span></div>
                <span class="hud__tab__graph" data-js-tab-graph="kv"></span>
            </button>
            <button class="hud__tab hud--mode-gas" data-js-toggle data-mode="gas" data-id="${sources.gas.id}" data-title="${sources.gas.title}" data-units="${sources.gas.unitsData}" data-firstdate="${sources.gas.firstDate}" data-max="${sources.gas.max}" data-max-hide="${sources.gas.maxHide}" data-in-out="${sources.gas.inOut}">
                <div class="hud__tab__name" aria-label="${sources.gas.title}">Gas</div>
                <div class="hud__tab__kw"><span data-js-tab-totals data-tab="gas">&#160;</span></div>
                <span class="hud__tab__graph" data-js-tab-graph="gas"></span>
            </button>
            <button class="hud__tab hud--mode-el" data-js-toggle data-mode="el" data-id="${sources.el.id}" data-title="${sources.el.title}" data-units="${sources.el.unitsData}" data-firstdate="${sources.el.firstDate}" data-max="${sources.el.max}" data-max-hide="${sources.el.maxHide}" data-in-out="${sources.el.inOut}">
                <div class="hud__tab__name" aria-label="${sources.el.title}">El</div>
                <div class="hud__tab__kw"><span data-js-tab-totals data-tab="el">&#160;</span></div>
                <span class="hud__tab__graph" data-js-tab-graph="el"></span>
            </button>
        </div>
    </section>`;
    }

    template += `
    <section class="hud__inner">`;

    // start of sidebar text
    if (!hideText) {
        template += `
        <section class="hud__text">

            <article class="hud__text__inner hud__text__inner--sol" data-hud-text="sol">
                <a class="hud__access" name="sol">Solenergi</a>
                <h2>Solenergi</h2>
                <p>
                    Solens strålar skulle potentiellt kunna driva alla världens samhällen, om vi bara lyckades ta tillvara energin. I Göteborg har vi Nya Solevi och Solinavium som omvandlar solens energi till el som sedan överförs via våra ledningar, kanske hem till dig?
                </p>
                <p>
                    <i>Solinstrålningen</i> är den effekt som absorberas av en svart yta som är 1 kvadratmeter stor.
                </p>
                <a href="https://www.goteborgenergi.se/privat/el/miljotillval/el-fran-solkraft" class="Ge-Btn Ge-Btn--primary" tabindex="-1">Läs mer om solenergi</a>
            </article>


            <article class="hud__text__inner hud__text__inner--vind" data-hud-text="vind">
                <a class="hud__access" name="vind">Vindkraft</a>
                <h2>Vindkraft</h2>
                <p>
                    Vindkraften är en viktig del av vägen till fossilfri energi. Det är ett billigt sätt att producera el eftersom det blåser året om. Storskalig lagring och överföring av vindel kommer vara viktiga utvecklingsområden de kommande decennierna. Vindkraften konkurrerar framförallt ut fossilbaserad elproduktion som kol och naturgas.
                </p>
                <a href="https://www.goteborgenergi.se/privat/el/miljotillval/el-fran-vindkraft" class="Ge-Btn Ge-Btn--primary" tabindex="-1">Läs mer om vindkraft</a>
            </article>


            <article class="hud__text__inner hud__text__inner--fv" data-hud-text="fv">
                <a class="hud__access" name="fv">Fjärrvärme</a>
                <h2>Fjärrvärme</h2>
                <p>
                    Vår fjärrvärme är ovanligt klok. Vi återvinner värme från avfallsförbränning och raffinaderier som räcker till 70 – 75% av stadens behov. Sedan använder vi restprodukter från skogsindustrin och fossil naturgas för att täcka upp behovet. Fjärrvärmen gör att Göteborg slipper använder stora mängder el för att värma staden, samtidigt som vi producerar mer el lokalt. Det hjälper till att fasa ut kolkraften i Europa och elektrifiera transporter och industrier. Fjärrvärmen är helt enkelt en viktig pusselbit i framtidens hållbara samhälle.
                </p>
                <a href="https://www.goteborgenergi.se/privat/fjarrvarme" class="Ge-Btn Ge-Btn--primary" tabindex="-1">Läs mer om Fjärrvärme</a>
            </article>


            <article class="hud__text__inner hud__text__inner--fk" data-hud-text="fk">
                <a class="hud__access" name="fk">Fjärrkyla</a>
                <h2>Fjärrkyla</h2>
                <p>
                    Fjärrkyla är lika klok som fjärrvärme. Här använder vi stadens stora överskott av värme för att skapa kyla. Dessutom tar vi tillvara mycket av den kyla som Göta älv erbjuder oss under stora delar av året. Vi använder också el för att göra fjärrkyla, men mycket mindre än vad konventionella kylmaskiner kräver. Tillsammans med fjärrvärme är det svårt att tänka sig en bättre helhetslösning för inomhusklimat. Dessutom är fjärrkyla tyst och i det närmaste underhållsfritt.
                </p>
                <a href="https://www.goteborgenergi.se/foretag/fjarrvarme-kyla/fjarrkyla" class="Ge-Btn Ge-Btn--primary" tabindex="-1">Läs mer om Fjärrkyla</a>
            </article>


            <article class="hud__text__inner hud__text__inner--kv" data-hud-text="kv">
                <a class="hud__access" name="kv">Kraftvärme (el)</a>
                <h2>Kraftvärme (el)</h2>
                <p>
                    I våra anläggningar för kraftvärme använder vi olika bränslen så effektivt som möjligt genom att producera både el och fjärrvärme. Den lokala elproduktionen är viktig eftersom det är trångt i kraftledningarna till Göteborg. Dessutom bättrar det på Sveriges elbalans så att mer kolkraft kan fasas ut i våra grannländer. Senast 2025 vill vi att all vår kraftvärme ska komma från förnybara källor. Det blir en viktig del av framtidens 100 % förnybara elsystem.
                </p>
                <!--<a href="https://www.goteborgenergi.se/" class="Ge-Btn Ge-Btn--primary" tabindex="-1">Läs mer om Kraftvärme</a>-->
            </article>


            <article class="hud__text__inner hud__text__inner--gas" data-hud-text="gas">
                <a class="hud__access" name="gas">Gas</a>
                <h2>Gas</h2>
                <p>
                    Här kan du se hur mycket naturgas som flödar igenom Göteborgs lokala naturgasnät. Naturgas är en fossil energikälla som används som råvara i industri, som värmekälla eller som fordonsbränsle. Oftast ersätter den ett annat bränsle eller råvara som är sämre för miljön.
                </p>
                <p>
                    Biogas är förnybar och kan användas på samma sätt som naturgas. Vår biogas produceras vid stadens avloppsreningsverk och tar vara på samhällets spill, med samma tänk som vår fjärrvärme. Ännu utgör biogas bara en bråkdel av Göteborgs totala användning av naturgas.
                </p>
                <a href="https://www.goteborgenergi.se/privat/gas" class="Ge-Btn Ge-Btn--primary" tabindex="-1">Läs mer om gas</a>
            </article>


            <article class="hud__text__inner hud__text__inner--el" data-hud-text="el">
                <a class="hud__access" name="el">El</a>
                <h2>El</h2>
                <p>
                    Göteborgs elnät har en hög tillförlitlighet men är beroende av elöverföring från andra delar av Sverige och även våra grannländer. Elöverföringen är begränsad och på många håll i Sverige finns problematik med eleffektbrister. Därför är det viktigt att vi funderar över vad vi ska använda vår el till i Göteborg så att vi inte slår i taket och hindras från att bygga fler industrier, bostäder eller skaffa fler elbilar. Fjärrvärme och fjärrkyla är bra på att spara el till annat än uppvärmning. Utan fjärrvärmen hade Göteborg förbrukat dubbelt så mycket el som idag.
                </p>
                <a href="https://www.goteborgenergi.se/privat/el" class="Ge-Btn Ge-Btn--primary" tabindex="-1">Läs mer om el</a>
            </article>
        
        </section>`;
    }

    // end of sidebar text

    template += `
        
        <figure class="hud">`;

    // start of cals buttons
    if (!hideCals) {
        template += `

            <button data-js-zoom="30days" class="hud__button hud__button--cal--30days" aria-label="visa 30 dagar">
                <span class="hud__button__label"><span class="Ge-Hide--xs Ge-Hide--sm Ge-Hide--md Ge-Hide--lg">Kal</span><span class="Ge-Hide--xxs">30 dagar</span></span>
                <svg viewBox="0 0 48 48" class="hud__button__svg">
                    <g transform="translate(1 1)">
                        <circle fill="rgba(255,255,255,0)" stroke="currentColor" stroke-width="2" cx="22.5" cy="22.5" r="22.5"></circle>
                        <g transform="translate(11 11)">
                        <rect width="6" height="6" stroke="none" fill="currentColor" transform="translate(0 0)" />
                        <rect width="6" height="6" stroke="none" fill="currentColor" transform="translate(9 0)" />
                        <rect width="6" height="6" stroke="none" fill="currentColor" transform="translate(18 0)" />
                        <rect width="6" height="6" stroke="none" fill="currentColor" transform="translate(0 9)" />
                        <rect width="6" height="6" stroke="none" fill="currentColor" transform="translate(9 9)" />
                        <rect width="6" height="6" stroke="none" fill="currentColor" transform="translate(18 9)" />
                        <rect width="6" height="6" stroke="none" fill="currentColor" transform="translate(0 18)" />
                        <rect width="6" height="6" stroke="none" fill="currentColor" transform="translate(9 18)" />
                        <rect width="6" height="6" stroke="none" fill="currentColor" transform="translate(18 18)" />
                    </g>
                </svg>
            </button>

            <button data-js-zoom="year" class="hud__button hud__button--cal--year" aria-label="visa 1 år">
                <span class="hud__button__label">1 år</span>
                <svg viewBox="0 0 48 48" class="hud__button__svg">
                    <g transform="translate(1 1)">
                        <circle fill="rgba(255,255,255,0)" stroke="currentColor" stroke-width="2" cx="22.5" cy="22.5" r="22.5"></circle>
                        <g transform="translate(11 11)">
                        <rect width="6" height="6" stroke="none" fill="currentColor" transform="translate(0 0)" />
                        <rect width="6" height="6" stroke="none" fill="currentColor" transform="translate(9 0)" />
                        <rect width="6" height="6" stroke="none" fill="currentColor" transform="translate(18 0)" />
                        <rect width="6" height="6" stroke="none" fill="currentColor" transform="translate(0 9)" />
                        <rect width="6" height="6" stroke="none" fill="currentColor" transform="translate(9 9)" />
                        <rect width="6" height="6" stroke="none" fill="currentColor" transform="translate(18 9)" />
                        <rect width="6" height="6" stroke="none" fill="currentColor" transform="translate(0 18)" />
                        <rect width="6" height="6" stroke="none" fill="currentColor" transform="translate(9 18)" />
                        <rect width="6" height="6" stroke="none" fill="currentColor" transform="translate(18 18)" />
                    </g>
                </svg>
            </button>`;
    }
    template += `

            <button data-js-today class="hud__button hud__button--cal--today" aria-label="tillbaka till idag">
                <span class="hud__button__label">idag</span>
                <svg viewBox="0 0 48 48" class="hud__button__svg">
                    <g transform="translate(1 1)">
                        <circle fill="rgba(255,255,255,0)" stroke="currentColor" stroke-width="2" cx="22.5" cy="22.5" r="22.5"></circle>
                        <path fill="currentColor" d="M26.097 22.366l-9.044 8.18L19.363 33 31 22.474 19.419 11 17 13.347"></path>
                    </g>
                </svg>
            </button>

            <div class="hud__width">

                <div class="hud__tabs__height">

                    <svg viewBox="0 0 960 960" id="hud-clock" class="hud__clock">
                        <mask id="extendedMask">
                            <circle cx="0" cy="0" r="${radius40 - 6}" fill="white" ></circle>
                            <circle cx="0" cy="0" r="${radius40 - 10}" stroke="black" stroke-width="2" fill="white" ></circle>
                            <circle cx="0" cy="0" r="${radius40 - 15}" stroke="black" stroke-width="2" fill="white" ></circle>
                            <circle cx="0" cy="0" r="${radius40 - 20}" stroke="black" stroke-width="2" fill="white" ></circle>
                            <circle cx="0" cy="0" r="${radius40 - 25}" stroke="black" stroke-width="2" fill="white" ></circle>
                            <circle cx="0" cy="0" r="${radius40 - 30}" stroke="black" stroke-width="2" fill="white" ></circle>
                        </mask>
                        <g class="hud__clock__track" transform="translate(480 480)"  aria-hidden="true"></g>
                        <g id="hud-clockgraph" class="hud__clockgraph" transform="translate(480 480)"></g>
                        <g class="hud__clock__indices" transform="translate(480 480)"  aria-hidden="true"></g>  
                    </svg>

                    <svg viewBox="0 0 960 960" id="hud-hub" class="hud__hub">
                        <g class="hud__discs__g" transform="translate(160 160)">
                            <circle class="hud__hub__fill" cx="320" cy="320" r="${radius05}" fill="none"></circle>
                            <circle class="hud__hub__ring" cx="320" cy="320" r="${radius08}" fill="none"></circle>
                        </g>
                        <g class="hud__numbers__g" transform="translate(160 140)">
                            <g id="hud-date-back" class="hud__hub__date__back" transform="translate(140 132)"><circle fill="rgba(255,255,255,0)" stroke="currentColor" stroke-width="2" cx="22.5" cy="22.5" r="22.5"/><path fill="currentColor" d="M26.097 22.366l-9.044 8.18L19.363 33 31 22.474 19.419 11 17 13.347" transform="rotate(-180 22.5 22.5)"/></g>
                            <text class="hud__hub__date"
                                text-anchor="middle">
                                <tspan 
                                id="hud-date"
                                alignment-baseline="middle"
                                x="320" 
                                y="160" 
                                dy="0">
                                    --
                                </tspan>
                            </text>
                            <g id="hud-date-forward" class="hud__hub__date__forward" transform="translate(450 132)"><circle fill="rgba(255,255,255,0)" stroke="currentColor" stroke-width="2" cx="22.5" cy="22.5" r="22.5"/><path fill="currentColor" d="M26.097 22.366l-9.044 8.18L19.363 33 31 22.474 19.419 11 17 13.347"/></g>
                            <text class="hud__hub__label1"
                                text-anchor="middle">
                                <tspan 
                                id="hud-hub-label1"
                                alignment-baseline="middle"
                                x="320" 
                                y="230" 
                                dy="0">
                                    <tspan alignment-baseline="middle" data-js-units>${unitsHub}</tspan>h <tspan alignment-baseline="middle" data-js-in-out>${inOut}</tspan>
                                </tspan>
                            </text>
                            <text class="hud__hub__number" 
                                x="325" 
                                y="375" 
                                dy="0" 
                                text-anchor="middle">
                                <tspan alignment-baseline="middle" dy="-10" class="hud__hub__number__inner hud__has-tooltip" id="hud-hub-value1" data-js-tooltip="number" data-tooltip-text="${sources.sol.toolTips[maxNu].number}">
                                    0,0
                                </tspan>
                            </text>
                        </g>
                        <g class="hud__hub__extra1" id="hud-hub-extra1" transform="translate(380 630)" data-js-tooltip="extra1" data-tooltip-text="${sources.sol.toolTips[maxNu].extra1}">
                            <circle class="hud__hub__extra1__circle hud__has-tooltip" cx="0" cy="0" r="80"></circle>
                            <text class="hud__hub__extra1__text" transform="translate(0 -20)" text-anchor="middle">
                                <tspan alignment-baseline="bottom" class="hud__hub__extra1__text__inner">
                                    <tspan alignment-baseline="bottom" data-js-units>${unitsHub}</tspan>
                                    <tspan alignment-baseline="bottom" data-js-max-nu>${maxNu}</tspan>
                                </tspan>
                            </text>
                            <text class="hud__hub__extra1__number" 
                                x="0" 
                                y="30" 
                                dy="0" 
                                text-anchor="middle">
                                <tspan alignment-baseline="bottom" class="hud__hub__number2__inner" id="hud-hub-value2">
                                    0
                                </tspan>
                            </text>
                        </g>
                        <g class="hud__hub__extra2" id="hud-hub-extra2" transform="translate(580 630)" data-js-tooltip="extra2" data-tooltip-text="${sources.sol.toolTips[maxNu].extra2}" aria-hidden="true">
                            <circle class="hud__hub__extra2__circle hud__has-tooltip" cx="0" cy="0" r="80"></circle>
                            <text class="hud__hub__extra2__text" transform="translate(0 -20)" text-anchor="middle">
                                <tspan alignment-baseline="bottom" class="hud__hub__extra2__text__inner" data-js-max-nu>
                                    ${maxNu}
                                </tspan>
                            </text>
                            <text class="hud__hub__extra2__number"
                                x="0.1em" 
                                y="30"
                                dy="0"
                                text-anchor="middle" >
                                <tspan alignment-baseline="bottom" class="hud__hub__number2__inner" id="hud-hub-value3">
                                    0%
                                </tspan>
                            </text>
                        </g>
                        <g transform="translate(160 160)" class="hud__title__g" aria-hidden="true">
                            <path id="curve1" d="M -40, ${radius20 - 40}
                                a ${radius20},${radius20} 0 1,0 ${2 * radius20},0" fill="none" transform="rotate(0 ${radius20 - 40} ${radius20 - 40})" />
                            <path id="curve2" d="M -40, ${radius20 + 1 - 40}
                                a ${radius20 + 1},${radius20 + 1} 0 1,0 ${2 * radius20 + 1},0" fill="none" transform="rotate(0 ${radius20 + 1 - 40} ${radius20 + 1 - 40})" />
                            <text text-anchor="middle">
                                <textPath xlink:href="#curve1" class="hud__title" id="hud-title" startOffset="50%">
                                    ${title}
                                </textPath>
                            </text>
                            <text text-anchor="middle" dy="12" dx="${titleOffset}">
                                <textPath xlink:href="#curve2" class="hud__key" id="hud-key" startOffset="50%"></textPath>
                            </text>
                        </g>
                    </svg>

                    <button type="button" class="hud__fullscreen__btn" data-js-fullscreen title="toggle full-screen" tabindex="-1">Full Screen</button>

                </div>
            </div>

            <button data-js-today type="button" class="hud__button hud__button--back hud__button--back--30days" aria-label="visar 30 dagar">
                <span class="hud__button__label">idag</span>
                <svg viewBox="0 0 48 48" class="hud__button__svg">
                    <g transform="translate(1 1)">
                        <circle fill="rgba(255,255,255,0)" stroke="currentColor" stroke-width="2" cx="22.5" cy="22.5" r="22.5"></circle>
                        <line x1="22.5" y1="8" x2="22.5" y2="37" stroke="currentColor" stroke-width="3" transform="rotate(-45 22.5 22.5)" />
                        <line x1="22.5" y1="8" x2="22.5" y2="37" stroke="currentColor" stroke-width="3" transform="rotate(45 22.5 22.5)" />
                    </g>
                </svg>
            </button>

            <button data-js-today type="button" class="hud__button hud__button--back hud__button--back--year" aria-label="tillbaka 1 år">
                <span class="hud__button__label">idag</span>
                <svg viewBox="0 0 48 48" class="hud__button__svg">
                    <g transform="translate(1 1)">
                        <circle fill="rgba(255,255,255,0)" stroke="currentColor" stroke-width="2" cx="22.5" cy="22.5" r="22.5"></circle>
                        <line x1="22.5" y1="8" x2="22.5" y2="37" stroke="currentColor" stroke-width="3" transform="rotate(-45 22.5 22.5)" />
                        <line x1="22.5" y1="8" x2="22.5" y2="37" stroke="currentColor" stroke-width="3" transform="rotate(45 22.5 22.5)" />
                    </g>
                </svg>
            </button>

            <div class="hud__longgraph" data-js-longgraph>
                <div class="hud__longgraph__track" data-js-longgraph-track>
                    <div class="hud__longgraph__shuttle" data-js-longgraph-shuttle>
                        <span class="hud__longgraph__stop hud__longgraph__stop--left" data-js-longgraph-stop="left"></span>
                        <svg viewBox="0 0 ${graphWidth} ${graphHeight}" id="hud-longgraph" class="hud__longgraph__svg">
                            <g id="hud-longgraph-graph-back" class="hud__longgraph__back" aria-hidden="true"></g>
                            <g id="hud-longgraph-graph-title" class="hud__longgraph__line__title" text-anchor="end" transform="translate(${graphWidth - 5} 530)"><text>Energi</text></g>
                            <g id="hud-longgraph-graph"></g>
                            <g id="hud-longgraph-line0" transform="translate(0 ${graph2Top})"></g>
                            <g id="hud-longgraph-line0-title" class="hud__longgraph__line__title" text-anchor="end" transform="translate(${graphWidth - 5} 15)"></g>
                            <g id="hud-longgraph-line1" transform="translate(0 ${graph3Top})"></g>
                            <g id="hud-longgraph-line1-title" class="hud__longgraph__line__title" text-anchor="end" transform="translate(${graphWidth - 5} 40)"></g>
                            <g id="hud-longgraph-graph-xaxis" class="hud__longgraph_xaxis" aria-hidden="true"></g>
                        </svg>
                        <span class="hud__longgraph__stop hud__longgraph__stop--right" data-js-longgraph-stop="right"></span>

                        <div class="hud__tooltip__outer hud__tooltip__outer--2" data-js-hud-tooltip2 aria-hidden="true">
                            <span class="hud__tooltip__arrow"></span>
                            <div class="hud__tooltip__inner" data-js-hud-tooltip-inner>
                                ...
                            </div>
                        </div>

                    </div>
                </div>
                <span class="hud__longgraph__shadow hud__longgraph__shadow--left" data-js-longgraph-shadow-left></span>
                <span class="hud__longgraph__shadow hud__longgraph__shadow--right" data-js-longgraph-shadow-right></span>

                <svg viewBox="0 0 960 960" id="hud-loading1" class="hud__hub__ring__loading1">
                    <g transform="translate(160 160)">
                        <circle cx="320" cy="320" r="${radius09}" fill="none"></circle>    
                    </g>
                </svg>

                <svg viewBox="0 0 960 960" id="hud-loading2" class="hud__hub__ring__loading2">
                    <g transform="translate(160 160)">
                        <circle cx="320" cy="320" r="${radius09}" fill="none"></circle>    
                    </g>
                </svg>
                
            </div>

            <div class="hud__tooltip__outer" data-js-hud-tooltip>
                <span class="hud__tooltip__arrow"></span>
                <div class="hud__tooltip__inner" data-js-hud-tooltip-inner>
                    ...
                </div>
            </div>

        </figure>
    
    </section>`;

    // const init = async function () {

    //     if (powerApiUrl) {
    //         initDate();
    //         await initCanvas();
    //         initD3();
    //         initTicker();
    //         checkForFullscreen();
    //         registerEvents();
    //         if (!hideText) {
    //             initText();
    //         }
    //         if (!hideTabs) {
    //             dataPullTabs();
    //         }
    //         drawClockIndices();
    //         toolTipInit();
    //         await drawClockSweep();
    //         dataPullDay().then(response => {
    //             dataDayProcess(response);
    //             initLabels();
    //             //drawRadialGraph();
    //             dataLongScrollObserver();
    //             try {
    //                 ga('send', { hitType: 'event', eventCategory: 'effektlev', eventAction: 'tab', eventLabel: 'solevi' });
    //                 ga('send', { hitType: 'event', eventCategory: 'effektlev', eventAction: 'zoom', eventLabel: 'day' });
    //             } catch (er) { }
    //         });
    //     } else {
    //         //console.log( '%c%s', 'color:#ccc;background:#666;padding:1em', 'waiting for load event.' );
    //         document.addEventListener('DOMContentLoaded', init);
    //     }
    // };

    const init = function () {

        if (powerApiUrl) {
            initDate();
            initCanvas().then(() => {
                initD3();
                initTicker();
                checkForFullscreen();
                registerEvents();
                if (!hideText) {
                    initText();
                }
                if (!hideTabs) {
                    dataPullTabs();
                }
                drawClockIndices();
                toolTipInit();
                drawClockSweep().then(() => {
                    dataPullDay().then(response => {
                        dataDayProcess(response);
                        initLabels();
                        //drawRadialGraph();
                        dataLongScrollObserver();
                        try {
                            ga('send', { hitType: 'event', eventCategory: 'effektlev', eventAction: 'tab', eventLabel: 'solevi' });
                            ga('send', { hitType: 'event', eventCategory: 'effektlev', eventAction: 'zoom', eventLabel: 'day' });
                        } catch (er) { }
                    });
                });
            });
        } else {
            //console.log( '%c%s', 'color:#ccc;background:#666;padding:1em', 'waiting for load event.' );
            document.addEventListener('DOMContentLoaded', init);
        }
    };

    // toggle between different tabs ("solevi", "el", "fv", etc)
    const toggleMode = function (button) {

        const newMode = button.getAttribute('data-mode');
        if (newMode === mode) {
            return;
        }
        mode = newMode;
        defaultMeasureId = button.getAttribute('data-id');
        title = button.getAttribute('data-title');
        unitsData = button.getAttribute('data-units');
        firstDate = button.getAttribute('data-firstdate');
        unitsHub = unitsData;
        inOut = button.getAttribute('data-in-out');

        optimumMax = button.getAttribute('data-max');
        optimumMaxHide = (button.getAttribute('data-max-hide') === 'true');
        addClass($canvas, 'hud--animate-out');
        $svg1Clock.selectAll('.hud__clockgraph__slice').remove();
        dataLongClear();

        setTimeout(() => {
            ['hud--with-max',
                'hud--mode-solevi',
                'hud--mode-sol',
                'hud--mode-utby',
                'hud--mode-vind',
                'hud--mode-fv',
                'hud--mode-fk',
                'hud--mode-el',
                'hud--mode-gas',
                'hud--mode-biogas',
                'hud--mode-kv',
                'hud--mode-naturalgas'
            ].forEach(cssClass => {
                removeClass($canvas, '.' + cssClass);
            });
            if ($canvas.getAttribute('class').indexOf('hud--mode-' + mode) < 0) {
                addClass($canvas, 'hud--mode-' + mode);
            }
            document.getElementById('hud-title').textContent = title;
            document.querySelector('[data-js-in-out]').textContent = inOut;
            const oldSunUpHour = sunUpHour;
            initDate();
            addClass($canvas, 'hud--animate-in');
            removeClass($canvas, 'hud--animate-out');
            setTimeout( () => {
                removeClass($canvas, 'hud--animate-in');
                if (sunUpHour !== oldSunUpHour) {
                    drawClockIndices();
                    // setTimeout(async () => {
                    //     drawClockSweep();
                    // }, 300);
                    setTimeout(() => {
                        drawClockSweep();
                    }, 300);
                }
                if (zoom) {
                    dataLongPull();
                    //return;
                }
                dataPullDay().then(response => {
                    dataDayProcess(response);
                    toggleLoadingMode('off');
                    updateUI();
                    try {
                        ga('send', { hitType: 'event', eventCategory: 'effektlev', eventAction: 'tab', eventLabel: mode });
                    } catch (er) { }
                });
            }, 20);
            // setTimeout(async () => {
            //     removeClass($canvas, 'hud--animate-in');
            //     if (sunUpHour !== oldSunUpHour) {
            //         drawClockIndices();
            //         setTimeout(async () => {
            //             await drawClockSweep();
            //         }, 300);
            //     }
            //     if (zoom) {
            //         dataLongPull();
            //         //return;
            //     }
            //     dataPullDay().then(response => {
            //         dataDayProcess(response);
            //         toggleLoadingMode('off');
            //         updateUI();
            //         try {
            //             ga('send', { hitType: 'event', eventCategory: 'effektlev', eventAction: 'tab', eventLabel: mode });
            //         } catch (er) { }
            //     });
            // }, 20);

            if (!hideText) {
                toggleText(mode);
            }

        }, 300);

    };

    const toggleText = function (newMode) {

        const $textsActive = document.querySelectorAll('.hud__text__inner--active');
        for (let i = 0; i < $textsActive.length; i++) {
            addClass($textsActive[i], 'hud__text__inner--exit');
            removeClass($textsActive[i], 'hud__text__inner--active');
        }
        const $ctas = document.querySelectorAll('.hud__inner a');
        for (let i = 0; i < $ctas.length; i++) {
            $ctas[i].tabIndex = -1;
        }
        setTimeout(() => {
            const $textsExit = document.querySelectorAll('.hud__text__inner--exit');
            for (let i = 0; i < $textsExit.length; i++) {
                removeClass($textsExit[i], 'hud__text__inner--exit');
            }
        }, 510);
        addClass(document.querySelector('[data-hud-text="' + newMode + '"]'), 'hud__text__inner--active');
        document.querySelector('[data-hud-text="' + newMode + '"] a').focus();
        const $ctasActive = document.querySelectorAll('[data-hud-text="' + newMode + '"] a');
        for (let i = 0; i < $ctasActive.length; i++) {
            $ctasActive[i].tabIndex = 0;
        }

    };

    let toggleTimeOut = false;
    // const toogleZoom = async function (newZoomLevel) {

    //     // debounce
    //     if (toggleTimeOut) {
    //         return;
    //     }
    //     toggleTimeOut = true;
    //     setTimeout(() => { toggleTimeOut = false; }, 500);

    //     if (newZoomLevel) {
    //         zoom = true;
    //         longMode = newZoomLevel || '30days';
    //         addClass($canvas, 'hud--zoom-cal');
    //         removeClass($canvas, 'hud--zoom-cal--30days');
    //         removeClass($canvas, 'hud--zoom-cal--year');
    //         addClass($canvas, 'hud--zoom-cal--' + longMode);
    //         dataLongShowShadow('left');
    //         setTimeout(() => {
    //             const track = document.querySelector('[data-js-longgraph-track]');
    //             track.scrollLeft = track.scrollWidth;
    //             try {
    //                 ga('send', { hitType: 'event', eventCategory: 'effektlev', eventAction: 'zoom', eventLabel: longMode });
    //             } catch (er) { }
    //         }, 50);
    //         //radius10 = radius10Cal;
    //         dataLongPull();
    //     } else {
    //         zoom = false;
    //         removeClass($canvas, 'hud--zoom-cal--30days');
    //         removeClass($canvas, 'hud--zoom-cal--year');
    //         removeClass($canvas, 'hud--zoom-cal');
    //         removeClass(document.querySelector('[data-js-longgraph]'), 'hud__longgraph--active');
    //         try {
    //             ga('send', { hitType: 'event', eventCategory: 'effektlev', eventAction: 'zoom', eventLabel: 'day' });
    //         } catch (er) { }
    //         //radius10 = radius10Day;
    //         dataLongClear(true);
    //     }

    // };
    const toogleZoom = function (newZoomLevel) {

        // debounce
        if (toggleTimeOut) {
            return;
        }
        toggleTimeOut = true;
        setTimeout(() => { toggleTimeOut = false; }, 500);

        if (newZoomLevel) {
            zoom = true;
            longMode = newZoomLevel || '30days';
            addClass($canvas, 'hud--zoom-cal');
            removeClass($canvas, 'hud--zoom-cal--30days');
            removeClass($canvas, 'hud--zoom-cal--year');
            addClass($canvas, 'hud--zoom-cal--' + longMode);
            dataLongShowShadow('left');
            setTimeout(() => {
                const track = document.querySelector('[data-js-longgraph-track]');
                track.scrollLeft = track.scrollWidth;
                try {
                    ga('send', { hitType: 'event', eventCategory: 'effektlev', eventAction: 'zoom', eventLabel: longMode });
                } catch (er) { }
            }, 50);
            //radius10 = radius10Cal;
            dataLongPull();
        } else {
            zoom = false;
            removeClass($canvas, 'hud--zoom-cal--30days');
            removeClass($canvas, 'hud--zoom-cal--year');
            removeClass($canvas, 'hud--zoom-cal');
            removeClass(document.querySelector('[data-js-longgraph]'), 'hud__longgraph--active');
            try {
                ga('send', { hitType: 'event', eventCategory: 'effektlev', eventAction: 'zoom', eventLabel: 'day' });
            } catch (er) { }
            //radius10 = radius10Day;
            dataLongClear(true);
        }

    };

    const goToDay = function (day) {

        if (!day) {
            let today = day || new Date();
            day = dateToISO(today);
        }
        filterObj.date = day;
        zoom = false;
        updateCycle();
        toogleZoom(false);

    };

    const updateCycle = function () {
        toggleLoadingMode('on');
        const oldSunUpHour = sunUpHour;
        dataInterval = sources[mode].dataInterval;
        initDate();
        // if we're staying in the same mode, but the date has changed significantly that we have a different sun-up/down time, we need to redraw the clock indices
        if (sunUpHour !== oldSunUpHour) {
            drawClockIndices();
        }
        dataPullDay().then(response => {
            toggleLoadingMode('off');
            dataDayProcess(response);
            updateUI();
        });
    };

    const updateUI = function () {

        maxNu = 'nu';
        if (!isToday(filterObj.date)) {
            maxNu = 'topp';
        }
        document.querySelector('[data-js-tooltip="number"]').setAttribute('data-tooltip-text', sources[mode].toolTips[maxNu].number);
        document.querySelector('[data-js-tooltip="extra1"]').setAttribute('data-tooltip-text', sources[mode].toolTips[maxNu].extra1);
        document.querySelector('[data-js-tooltip="extra2"]').setAttribute('data-tooltip-text', sources[mode].toolTips[maxNu].extra2);

        const maxNus = document.querySelectorAll('[data-js-max-nu]');
        for (let i = 0; i < maxNus.length; i++) {
            maxNus[i].textContent = maxNu;
        }
        const units = document.querySelectorAll('[data-js-units]');
        for (let i = 0; i < units.length; i++) {
            units[i].textContent = unitsHub;
        };

        // key
        if (document.querySelector('.hud__key__dot')) {
            var dots = document.querySelectorAll('.hud__key__dot');
            var dotTexts = document.querySelectorAll('.hud__key__text')
            dots = [].slice.call(dots);
            dotTexts = [].slice.call(dotTexts);
            dots.forEach(el => { el.parentNode.removeChild(el) });
            dotTexts.forEach(el => { el.parentNode.removeChild(el) });
        }
        if ((sources[mode].id + '').indexOf(',') >= 0) {
            const ids = multiIdParse(sources[mode].id).ids;
            const sourceLookup = []; // stops showing the same type + class twice eg, if one source is 'fossil' and a second is also 'fossil', it'll filter them to only show one dot, not two
            ids.forEach((id) => {
                const sourceMeta = sourcesMeta[id];
                if (sourceMeta && sourceLookup.indexOf(sourceMeta.type + ':' + sourceMeta.class) < 0) {

                    const dotTSpan = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
                    dotTSpan.setAttribute('class', 'hud__key__dot hud__key__dot--' + sourceMeta.class);
                    const dotContent = document.createTextNode("●");
                    dotTSpan.appendChild(dotContent);
                    document.getElementById('hud-key').appendChild(dotTSpan);

                    const textTSpan = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
                    textTSpan.setAttribute('class', 'hud__key__text hud__key__text--' + sourceMeta.class);
                    const textContent = document.createTextNode(sourceMeta.type + ' ');
                    textTSpan.appendChild(textContent);
                    document.getElementById('hud-key').appendChild(textTSpan);

                    sourceLookup.push(sourceMeta.type + ':' + sourceMeta.class);
                }
            });
        }
        //initDate();
        drawClockSweep();
        initLabels();
        drawRadialGraph();
    };

    const initCanvas = function () {

        return new Promise((resolve, reject) => {

            addClass($canvas, 'hud__outer');
            addClass($canvas, 'hud--mode-' + mode);
            addClass($inner, 'Ge-HeroFull-Inner--hud1');
            setTimeout(() => {
                $inner.innerHTML = template;
                addClass($inner, 'Ge-HeroFull-Inner--hud2');
                $hudHubValue1 = $inner.querySelector('#hud-hub-value1');
                $hudHubValue2 = $inner.querySelector('#hud-hub-value2');
                $hudHubValue3 = $inner.querySelector('#hud-hub-value3');
                $hudHubExtra1 = $inner.querySelector('#hud-hub-extra1');
                $hudHubExtra2 = $inner.querySelector('#hud-hub-extra2');
                $hudLoading1 = $inner.querySelector('#hud-loading1');
                $hudLoading2 = $inner.querySelector('#hud-loading2');
                resolve();
            }, 1100)

        });

    };

    const initD3 = function () {

        $svg1Clock = d3.select($inner).select('#hud-clock');
        $svg1ClockGraph = d3.select($inner).select('#hud-clockgraph');
        $svg1LongGraph = d3.select($inner).select('#hud-longgraph-graph');
        $svg1LongGraphAxis = d3.select($inner).select('#hud-longgraph-graph-xaxis');
        $svg1LongGraphBack = d3.select($inner).select('#hud-longgraph-graph-back');
        $svg1LongGraphLine1 = d3.select($inner).select('#hud-longgraph-line0');
        $svg1LongGraphLine1Title = d3.select($inner).select('#hud-longgraph-line0-title');
        $svg1LongGraphLine2 = d3.select($inner).select('#hud-longgraph-line1');
        $svg1LongGraphLine2Title = d3.select($inner).select('#hud-longgraph-line1-title');

    };

    const initTicker = function () {

        const tick = function () {
            tickDate = new Date();

            // loop subscriptions to the ticker
            tickSubs.forEach((subscription, index) => {

                // skip running items, they need room to complete
                if (subscription.status === 'running') {
                    return;
                }

                // types of work to be performed

                // api call
                if (subscription.type === 'api') {
                    /* 
                    EXAMPLE CONFIG
                    {
                        id          : 'powerAPI',
                        status      : 'waiting',
                        type        : 'api',
                        lastDate    : parseUTC( latestReading.dateTime ),
                        nextDate    : sixtySecsAhead, // pull again in 60 seconds
                        callback    : dataPullDay
                    }
                    */
                    if (tickDate.getTime() > subscription.nextDate.getTime()) {
                        tickSubs[index].status = 'running';
                        subscription.callback();
                    }
                    // complex number ticker
                } else if (subscription.type === 'numberInterpolate') {
                    numberInterpolateUpdate(subscription, index);
                    // simple number ticker
                } else if (subscription.type === 'numberSimple') {
                    numberSimpleUpdate(subscription, index);
                }

            });

            // and deja vu all over again
            window.requestAnimationFrame(() => {
                tick();
            });
        }
        // start ticker
        tick();

    };

    const initText = function () {

        setTimeout(() => {
            toggleText(mode);
        }, 1000);

    };

    const updateTickerSubscription = function (payload) {

        const subscriptionId = payload.id;
        const subscriptionIndex = tickSubsLookup[subscriptionId];

        // new subscription
        if (subscriptionIndex === undefined) {
            tickSubs.push(payload);
            tickSubsLookup[subscriptionId] = tickSubs.length - 1;
            // update subscription
        } else {
            tickSubs[subscriptionIndex] = payload;
        }

    };

    const initLabels = function () {

        const humanDate = function (dateISO) {

            const dateObj = parseUTC(dateISO);
            const dateDayLookup = ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'];
            const dateMonthLookup = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
            return (new Date().getYear() !== dateObj.getYear() ? '' : dateDayLookup[dateObj.getDay()]) + ' ' + dateObj.getDate() + ' ' + dateMonthLookup[dateObj.getMonth()] + (new Date().getYear() !== dateObj.getYear() ? ' ' + (dateObj.getYear() + '').substr(1) : '');
        };

        if (isToday(filterObj.date)) {
            document.querySelector('#hud-date').textContent = 'idag'
        } else {
            document.querySelector('#hud-date').textContent = humanDate(filterObj.date);
        }
        if ($canvas.getAttribute('class').indexOf('hud--active') < 0) {
            addClass($canvas, 'hud--active');
        }
        drawCurrent();

    };

    const initDate = function () {

        dataDate = new Date(filterObj.date);
        // missing date = today
        if (!(dataDate instanceof Date) || isNaN(dataDate)) {
            dataDate = new Date();
            filterObj.date = dateToISO(dataDate);
        }
        // exampt pre data-collection
        removeClass($canvas, 'hud__date--first');
        removeClass($canvas, 'hud__date--today');
        if (dataDate < new Date(firstDate)) {
            filterObj.date = firstDate;
            dataDate = parseUTC(filterObj.date);
            currentHour = 24;
            // if filter is to a day other than today (and not in the future)
        } else if (!isToday(filterObj.date) && !(dataDate > tickDate)) {
            currentHour = 24;
            // otherwise - must be today!
        } else {
            dataDate = tickDate;
            filterObj.date = dateToISO(dataDate);
            currentHour = parseFloat(dataDate.getHours() + '.' + ((dataDate.getMinutes() * 100) / 60).toFixed(0).padStart(2, '0'));
            addClass($canvas, 'hud__date--today');
        }
        // if the first accesptable date, mark it
        if (filterObj.date === firstDate) {
            addClass($canvas, 'hud__date--first');
        }

        // get sun up/down times
        const weekNo = dataDate.getWeek() || 1;
        let sunUpDownWeek = sunUpDown[weekNo];
        if (!sunUpDownWeek) {
            console.error('no sun up/down data found for week ' + weekNo);
            errorMode();
            return;
        }

        sunUpHour = 0;
        sunDownHour = 24;
        if (['solevi', 'sol', 'utby'].indexOf(mode) !== -1) {
            sunUpHour = parseUTC(sunUpDownWeek[0]).getHours() + sunUpNudge;
            sunDownHour = parseUTC(sunUpDownWeek[1]).getHours() + sunDownNudge;
        }

        // current percntage through "day" period
        const dayPeriod = (sunDownHour - sunUpHour);
        const slots = dayPeriod * 6;
        const slotPerc = 1 / slots;
        currentPerc = Math.min((currentHour - sunUpHour) / dayPeriod, 1);
        currentPerc = Math.ceil(currentPerc / slotPerc) * slotPerc;
        if (currentPerc < 0) {
            currentPerc = 0;
        }
        //console.log('%c%s', 'color:#80C4CE;background:#0e3f42;padding:0.2em', 'DATE/TIME', 'filterObj.date', filterObj.date, 'isToday', isToday(filterObj.date), 'sun up', sunUpHour, 'sun down', sunDownHour, 'currentHour', currentHour, 'perc', currentPerc );
    };

    const registerEvents = function () {
        window.addEventListener('keyup', keyboardEvents, false);
        window.addEventListener('keydown', keyboardModifierEvents, false);
        if (document.querySelector('[data-js-fullscreen]')) {
            document.querySelector('[data-js-fullscreen]').addEventListener('click', toggleFullScreen, false);
        }
        document.addEventListener('fullscreenchange', checkFullScreen, false);

        document.querySelector('#hud-date-back').addEventListener('click', stepBack, false);
        document.querySelector('#hud-date-forward').addEventListener('click', stepForward, false);

        window.addEventListener('touchstart', touchEventsStart, false);
        window.addEventListener('touchend', touchEventsEnd, false);
        window.addEventListener('touchcancel', touchEventsCancel, false);

        document.addEventListener('click', (ev) => {
            if (ev.target.matches('[data-js-toggle]')) {
                toggleMode(ev.target);
            } else if (ev.target.closest('[data-js-toggle]')) {
                toggleMode(ev.target.closest('[data-js-toggle]'));
            }
        });
        document.querySelector('#hud-date').addEventListener('click', toogleZoom, false);

        const zooms30Days = document.querySelectorAll('[data-js-zoom="30days"]');
        for (let i = 0; i < zooms30Days.length; i++) {
            zooms30Days[i].addEventListener('click', (ev) => {
                toogleZoom('30days');
            }, false);
        };
        const zoomsYear = document.querySelectorAll('[data-js-zoom="year"]');
        for (let i = 0; i < zoomsYear.length; i++) {
            zoomsYear[i].addEventListener('click', (ev) => {
                toogleZoom('year');
            }, false);
        };

        const todays = document.querySelectorAll('[data-js-today]');
        for (let i = 0; i < todays.length; i++) {
            todays[i].addEventListener('click', goToDay, false);
        };

        document.addEventListener('mousemove', (ev) => {
            if (ev.target.matches('[data-js-tooltip]')) {
                toolTip(ev, ev.target);
            } else if (ev.target.closest('[data-js-tooltip]')) {
                toolTip(ev, ev.target.closest('[data-js-tooltip]'));
            }
        });
        document.addEventListener('mouseout', (ev) => {
            if (ev.target.matches('[data-js-tooltip]') || ev.target.closest('[data-js-tooltip]')) {
                toolTipClose(ev);
            }
        });
        document.addEventListener('touchstart', (ev) => {
            if (ev.target.matches('[data-js-tooltip]')) {
                toolTip(ev, ev.target);
            } else if (ev.target.closest('[data-js-tooltip]')) {
                toolTip(ev, ev.target.closest('[data-js-tooltip]'));
            }
        });
    };

    const stepBack = function () {
        dataDate = dataDate.addDays(-1);
        filterObj.date = dateToISO(dataDate);
        updateCycle();
        try {
            ga('send', { hitType: 'event', eventCategory: 'effektlev', eventAction: 'nav', eventLabel: 'prev' });
        } catch (er) { }
    };

    const stepForward = function () {
        dataDate = dataDate.addDays(1);
        filterObj.date = dateToISO(dataDate);
        updateCycle();
        try {
            ga('send', { hitType: 'event', eventCategory: 'effektlev', eventAction: 'nav', eventLabel: 'next' });
        } catch (er) { }
    };

    // left/right button clicks.
    const keyboardEvents = function (ev) {

        // // on release of the modifier key, full screen button is hidden again
        document.querySelector('[data-js-fullscreen]').classList.remove('hud__fullscreen__btn--visible');

        // no keyboard left-right in calendar mode
        if (zoom) {
            return;
        }
        var key = ev.keyCode ? ev.keyCode : ev.which;
        if (key === 37) {
            stepBack();
        } else if (key === 39) {
            stepForward();
        }

    };

    // holding down shift reveals easter eggs. click ih
    const keyboardModifierEvents = function (ev) {

        var key = ev.keyCode ? ev.keyCode : ev.which;
        // when holding the shift key,
        // the full screen button is revealed
        if (key === 16) {
            document.querySelector('[data-js-fullscreen]').classList.add('hud__fullscreen__btn--visible');
        }
        // click "H" when in full screen and all tabs, text and navigation disappears
        if (key === 72 && document.querySelector('.hud--fullscreen-active')) {
            document.querySelector('.hud--fullscreen-active').classList.add('hud--fullscreen-hide-chrome');
        }

    }

    const touchEventsStart = function (ev) {
        // no keyboard left-right in calendar mode
        if (zoom) {
            return;
        }
        const touches = ev.touches;
        if (touches.length === 1) {
            touchEvents.x = touches[0].pageX;
            touchEvents.y = touches[0].pageY;
        } else {
            touchEvents = {}
        }

    };

    const touchEventsEnd = function (ev) {

        const touches = ev.changedTouches;
        if (zoom) {
            return;
        }
        if (touches.length === 1) {
            const newX = touches[0].pageX;
            const newY = touches[0].pageY;
            const vectorX = newX - touchEvents.x;
            const vectorY = newY - touchEvents.y;
            const minToSwipe = 100;
            if (Math.abs(vectorX) > Math.abs(vectorY) && vectorX < (minToSwipe * -1)) {
                stepForward();
            } else if (Math.abs(vectorX) > Math.abs(vectorY) && vectorX > minToSwipe) {
                stepBack();

            }
        }
        touchEvents = {}

    };

    const unitsOut = function (unitsIn, value, fixed) {
        let units = unitsIn;
        value = parseFloat(value);
        fixed = fixed || 1;
        if (units === 'kW' && parseInt(value) > 1000) {
            value = value / 1000;
            units = 'MW';
        }
        return {
            value: value.toFixed(fixed),
            units: units
        }
    };

    const touchEventsCancel = function (ev) {
        console.log('touchEventsCancel', ev)
        touchEvents = {};
    };

    let toolTipTimer = null;
    let toolTipType = null;
    let $toolTip1 = document.querySelector('[data-js-hud-tooltip]');
    let $toolTip2 = document.querySelector('[data-js-hud-tooltip2]');
    let toolTipId = null;
    let toolTipBoundaries = [];

    const toolTipInit = function () {
    };

    const toolTip = function (ev, $elem) {

        let scrollAdjustX = 0;
        let scrollAdjustY = 0;

        // if late renedered
        if (!$toolTip1) {
            $toolTip1 = document.querySelector('[data-js-hud-tooltip]');
            $toolTip2 = document.querySelector('[data-js-hud-tooltip2]');
        }

        // which tooltip?
        toolTipType = 0;
        let $toolTip = $toolTip1;
        const isToolTip2 = $elem.hasAttribute('data-js-tooltip2');
        if (isToolTip2) {
            toolTipType = 1;
            $toolTip = $toolTip2;
        }
        const $toolTipInner = $toolTip.querySelector('[data-js-hud-tooltip-inner]');

        // error checking
        if (longDataObj && longDataObj[1] && Object.keys(longDataObj[1]).length < 10) {
            return;
        }

        // 
        clearTimeout(toolTipTimer);
        const newToolTipId = $elem.getAttribute('data-js-tooltip');
        let toolTipBoundaryDims = null;
        let shuttleBoundaryDims = null;
        scrollAdjustY = document.documentElement.scrollTop;
        let topOffset = 0;
        if (toolTipType === 1) {
            toolTipBoundaryDims = document.querySelector('[data-js-longgraph]').getBoundingClientRect();
            const track = document.querySelector('[data-js-longgraph-track]');
            const shuttle = document.querySelector('[data-js-longgraph-shuttle]');
            shuttleBoundaryDims = shuttle.getBoundingClientRect();
            scrollAdjustX = track.scrollLeft - 20;
            topOffset = -100;

        } else {
            toolTipBoundaryDims = document.querySelector('.hud').getBoundingClientRect();
        }
        $toolTip.style.top = (ev.clientY - toolTipBoundaryDims.top + topOffset) + 'px';
        $toolTip.style.left = (ev.clientX - toolTipBoundaryDims.left + scrollAdjustX) + 'px';

        if (!$toolTip.classList.contains('hud__tooltip--active') || newToolTipId !== toolTipId) {
            toolTipId = newToolTipId;
            const toolTipText = $elem.getAttribute('data-tooltip-text');
            $toolTipInner.innerText = toolTipText;
            if ($elem.hasAttribute('data-tooltip-long-data')) {
                const index = $elem.getAttribute('data-tooltip-long-data');
                // error out
                if (!longDataObj[1] || !longDataObj[1][index]) {
                    return;
                }

                let value = (longDataObj[1][index].value * 24).toFixed(1);
                const unitsValueOut = unitsOut(unitsData, value);
                value = unitsValueOut.value;
                let units = unitsValueOut.units;
                let buffer = `
                    ${$toolTipInner.innerText}<br />
                    ${value}${units}h
                `;
                if (toolTipType === 1 && secondDataObj[0] && sources[mode].secondary[0]) {
                    let value2 = (secondDataObj[0][index].value).toFixed(1);
                    const units2 = sources[mode].secondary[0].unitsData;
                    // in a 30 day graph, the results are hourly, but we want a day average. We cheat slightly, calc the index of the first hour of this day, loop 24 hours and do an average.
                    if (longMode !== 'year') {
                        const secondDataObjDay = secondDataObj[0].slice(index * 24, index * 24 + 24);
                        let total = 0;
                        for (let i = 0; i < secondDataObjDay.length; i++) {
                            total += secondDataObjDay[i].value;
                        }
                        value2 = (total / secondDataObjDay.length).toFixed(1);
                    }
                    buffer += `
                    <br />
                    ${value2}${units2}
                    `;
                }
                buffer += `
                    <br />
                    klicka för detaljer
                `;
                $toolTipInner.innerHTML = buffer;
            }
            removeClass($toolTip, 'hud__tooltip--active-left');
            removeClass($toolTip, 'hud__tooltip--active-right');
            addClass($toolTip, 'hud__tooltip--active');
            if (toolTipType === 1 && ev.clientX - toolTipBoundaryDims.left + scrollAdjustX < 100) {
                addClass($toolTip, 'hud__tooltip--active-left');
            } else if (toolTipType === 1 && shuttleBoundaryDims.width - (ev.clientX - toolTipBoundaryDims.left + scrollAdjustX) < 100) {
                addClass($toolTip, 'hud__tooltip--active-right');
            }
        }

    };
    const toolTipClose = function (ev) {
        toolTipTimer = setTimeout(() => {
            toolTipId = null;
            removeClass($toolTip2, 'hud__tooltip--active-left');
            removeClass($toolTip2, 'hud__tooltip--active-right');
            removeClass($toolTip1, 'hud__tooltip--active');
            removeClass($toolTip2, 'hud__tooltip--active');
            if ($toolTip1.hasAttribute('style')) {
                $toolTip1.setAttribute('style', '');
            }
            if ($toolTip2.hasAttribute('style')) {
                $toolTip2.setAttribute('style', '');
            }
            const toolTipInners = $toolTip1.querySelectorAll('[data-js-hud-tooltip-inner]');
            for (let i = 0; i < toolTipInners.length; i++) {
                toolTipInners[i].innerText = '';
            };
            $toolTip2.querySelector('[data-js-hud-tooltip-inner]').innerText = '';
        }, 100);
    };


    const numberInterpolateUpdate = function (config, index) {

        /*
            EXAMPLE CONFIG
        {
            id              : 'kWhTotal',
            status          : 'constant',
            type            : 'numberInterpolate',
            $el             : $hudHubValue1,
            readingTime     : parseUTC( latestReading.dateTime ),
            readingNumber   : data[ Math.max( data.length - 2, 0 ) ].cumulative,
            timePerSegment  : ( 24/dataSegmentCount ) * 1000*60*60,
            diffPerSegment  : predictNextReading(),
            decimal         : 1
        };
        */

        const readingKwh = config.readingNumber;
        const readingTime = config.readingTime;
        const timePerSegment = config.timePerSegment;
        const diffPerSegment = config.diffPerSegment;


        config.decimal = 1;
        if (parseInt(readingKwh) < 10000) {
            config.decimal = 2;
        }

        const nowDiff = tickDate.getTime() - readingTime.getTime();

        // if the diff is more than an hour, do a quick count
        if (nowDiff > 1000 * 60 * 60 * 3) {
            numberSimpleUpdate(config, index);
            // otherwise interpolate based on time since the reading
        } else {
            const newReading = (nowDiff / timePerSegment * diffPerSegment) + readingKwh;
            numberPrint(config, newReading);
        }
    }

    function getCurrentNumber(config) {
        const $el = config.$el;
        let currentNumber = null;
        if ($el.textContent && $el.textContent.length) {
            currentNumber = parseFloat($el.textContent.replace(String.fromCharCode(160), '').replace(',', '.'));
        }
        if (isNaN(currentNumber)) {
            currentNumber = 0;
        }
        return currentNumber;
    }

    // tick a number up/down to a predermined value
    const numberSimpleUpdate = function (config, index) {

        /*
            EXAMPLE CONFIG
        {
            id              : 'kwPercent',
            status          : 'constant',
            type            : 'numberSimple',
            $el             : $hudHubValue3,
            readingTime     : tickDate,
            readingNumber   : percentageEfficiency,,
            decimal         : 1,                    // opt
            suffix          : '%',                  // opt
            duration        : 1000,                 // opt
        };
        */

        // set up
        const readingNumber = config.readingNumber;
        let readingNumberRounded = readingNumber;
        let deceimalCoef = 0;
        const currentNumber = getCurrentNumber(config);
        if (config.decimal) {
            deceimalCoef = config.decimal * 10;
            readingNumberRounded = (Math.round(readingNumber * deceimalCoef)) / deceimalCoef;
        } else {
            readingNumberRounded = Math.round(readingNumber)
        }

        // no change from current value? exit
        if (currentNumber === readingNumberRounded) {
            tickSubs[index].startTime = null;
            tickSubs[index].startNumber = 0;
            return;
        }
        // have we already added a start time to the subscription? We need one to create the diff, add one now if we need to
        let startTime = new Date();
        let startNumber = 0;
        if (tickSubs[index].startTime) {
            startTime = tickSubs[index].startTime;
            startNumber = tickSubs[index].startNumber;
        } else {
            tickSubs[index].startTime = startTime;
            tickSubs[index].startNumber = currentNumber;
        }
        // calc the NEW current number based on the number diff, the duration and the time since start
        const duration = config.duration || 1000;
        const nowDiff = tickDate.getTime() - startTime.getTime();
        const diff = readingNumber - startNumber;
        //console.log('nowDiff!!!', config.id, readingNumber, currentNumber, diff, ( nowDiff/duration ) , ( nowDiff/duration ) * diff )
        let newReading = readingNumber;
        if (nowDiff < duration) {
            newReading = ((nowDiff / duration) * diff) + startNumber;
        }
        // print the number
        numberPrint(config, newReading);

    };

    const numberPrint = function (config, newReading) {

        const $el = config.$el;
        let humanNumber = newReading;
        let decimalSuffix = '';
        let suffix = config.suffix || '';
        let deceimalCoef = 0;
        let decimalBreakPoint = config.decimalBreakPoint || 999999999;
        // decimal the number?
        if (config.decimal && newReading < decimalBreakPoint) {
            deceimalCoef = Math.pow(10, config.decimal);
            let decimalisedNumber = (Math.round(humanNumber * deceimalCoef)) / deceimalCoef;
            humanNumber = decimalisedNumber.toLocaleString('sv-SE');
            if (humanNumber.indexOf(',') === humanNumber.length - config.decimal && humanNumber.indexOf(',') > 0) {
                humanNumber += '0';
            }
            if (decimalisedNumber === Math.round(newReading)) {
                decimalSuffix = ',' + new Array(config.decimal).fill('0').join('');
            }
            // rounded number
        } else {
            humanNumber = Math.round(humanNumber).toLocaleString('sv-SE');
        }
        humanNumber = humanNumber.replace(String.fromCharCode(160), '') + decimalSuffix + suffix;
        if ($el.textContent !== humanNumber) {
            $el.textContent = humanNumber;
        }

    };

    const drawClockIndices = function () {

        return new Promise((resolve, reject) => {

            // DRAW THE CLOCK CHAPTER  RING

            const arc = d3.arc()
                .innerRadius(radius40)
                .outerRadius(radius40 + 2)
                .startAngle(Math.radians(sweepAngleStart));

            const arcTween = function (newRadians) {
                return function (d) {
                    const interpolate = d3.interpolate(d.endAngle, newRadians);
                    return function (t) {
                        d.endAngle = interpolate(t);
                        return arc(d);
                    };
                };
            };

            const $clockIndices = $svg1Clock.select('.hud__clock__indices');

            const clockChapter = $clockIndices
                .append("path")
                .datum({ endAngle: Math.radians(sweepAngleStart) })
                .classed('hud__clock__ring', true)
                .attr('d', arc);

            clockChapter
                .transition()
                .delay(100)
                .duration(1000)
                .attrTween('d', arcTween(Math.radians(sweepAngleEnd)));

            // DRAW THE CLOCK INDICES

            $clockIndices.select('.hud__clock__indices').remove();

            const hours = sunDownHour - sunUpHour;
            const indicesData = d3.range(sweepAngleStart, sweepAngleEnd, (sweepAngleEnd - sweepAngleStart) / (hours * 4));
            indicesData.reverse();

            const clockIndices = $clockIndices.append('g')
                .classed('hud__clock__indices', true)
                .attr('transform', 'rotate(-90)')
                .selectAll(".hud__clock__index")
                .data(indicesData)

            const clockIndicesEnter = clockIndices
                .enter()
                .append("line")
                .classed('hud__clock__index', true)
                .attr("x1", radius40)
                .attr("x2", radius40)
                .attr("transform", d => { return "rotate(" + -d + ")"; });

            clockIndices.merge(clockIndicesEnter)
                .transition()
                .duration(1000)
                .delay(function (d, i) { return i * 20; })
                .attr("x1", radius30)
                .attr("x2", radius40);


            // DRAW THE CLOCK INDICES' LABELS

            $clockIndices.select('.hud__clock__labels').remove();

            const radiusLabel = radius40 + (25);
            const labelsData = d3.range(sweepAngleStart, sweepAngleEnd, (sweepAngleEnd - sweepAngleStart) / hours);
            labelsData.reverse();

            const clockLabels = $clockIndices.append('g')
                .classed('hud__clock__labels', true)
                .attr('transform', 'rotate(-90)')
                .selectAll(".hud__clock__label")
                .data(labelsData)

            const clockLabelsEnter = clockLabels
                .enter()
                .append("g")
                .classed('hud__clock__label', true)
                .attr("transform", function (d) { return "rotate(" + -d + ")"; })
                .append("text")
                .attr("x", radiusLabel)
                .attr("dy", ".35em")
                .attr("dx", "-.5em")
                .attr("transform", function (d) { return d < 180 && d > 0 ? "rotate(270 " + radiusLabel + " 0)" : "rotate(90 " + radiusLabel + " 0)"; });

            const clockLabelsTransition = clockLabels.merge(clockLabelsEnter)
                .transition()
                .duration(1000)
                .delay(500)
                .text((d, i) => { return ((i + sunUpHour + 1) + '').padStart(2, '0'); })
                .on("end", resolve);

        });

    }

    let clockD3 = null;
    const drawClockSweep = function () {

        var myScale = d3.scaleLinear()
            .domain([0, 1])
            .range([Math.radians(sweepAngleStart), Math.radians(sweepAngleEnd)]);

        const arc = d3.arc()
            .innerRadius(radius10)
            .outerRadius(radius40)
            .startAngle(Math.radians(sweepAngleStart));

        const arcTween = function (newRadians) {
            return function (d) {
                const interpolate = d3.interpolate(d.endAngle, newRadians);
                return function (t) {
                    d.endAngle = interpolate(t);
                    return arc(d);
                };
            };
        };

        return new Promise((resolve, reject) => {

            // DRAW THE CLOCK SWEEP

            const $clockTrack = $svg1Clock.select('.hud__clock__track');

            // only on initial phase
            if (!clockD3) {

                clockD3 = $clockTrack
                    .append("path")
                    .datum({ endAngle: Math.radians(sweepAngleStart) })
                    .classed('hud__clock__sweep', true)
                    .attr('d', arc);
            }

            clockD3
                .transition()
                .duration(1000)
                .attrTween('d', arcTween(myScale(currentPerc)))
                .on("end", resolve);
        });

    }

    const drawCurrent = function () {
        if ($hudHubExtra1.getAttribute('class').indexOf('hud__hub__extra1--active') < 0) {
            addClass($hudHubExtra1, 'hud__hub__extra1--active');
        }
        if (!optimumMaxHide && parseInt(optimumMax) > 0) {
            if ($hudHubExtra2.getAttribute('class').indexOf('hud__hub__extra2--active') < 0) {
                addClass($hudHubExtra2, 'hud__hub__extra2--active');
            }
            $hudHubExtra1.setAttribute('transform', 'translate(380 630)');
        } else {
            removeClass($hudHubExtra2, 'hud__hub__extra2--active');
            $hudHubExtra1.setAttribute('transform', 'translate(480 630)');
        }

    };

    const errorMode = function () {
        $hudHubValue1.textContent = '--';
    };

    const toggleLoadingMode = function (onOff) {

        if (onOff === 'on') {
            addClass($hudLoading1, 'hud__hub__ring__loading1--active');
            addClass($hudLoading2, 'hud__hub__ring__loading2--active');
        } else {
            removeClass($hudLoading1, 'hud__hub__ring__loading1--active');
            removeClass($hudLoading2, 'hud__hub__ring__loading2--active');
        }

    };

    // used where the measure id field is actually several IDs to be agregated into one graph.
    // eg solevi is just one id "96988", but Fjärrevärme has an id of '74645,MW,16800,MW,60434,MW',
    // which is three seperate measureIds, along with the unit ofthe data they return.
    // this parses the id into multiple ids.
    const multiIdParse = function (measureId) {

        if ((measureId + '').indexOf(',') < 0) {
            const output = {
                ids: [measureId],
                units: ['MW'],
                lookup: {}
            };
            output.lookup[measureId] = 'MW';
            return output;
        }
        const temp = measureId.split(',');
        const thisMeasureId = [temp[0], temp[2]];
        if (temp[4]) {
            thisMeasureId.push(temp[4]);
        }
        const duoUnitsData = [temp[1], temp[3]];
        if (temp[5]) {
            duoUnitsData.push(temp[5]);
        }
        const duoUnitsLookUp = {};
        duoUnitsLookUp[temp[0]] = temp[1];
        duoUnitsLookUp[temp[2]] = temp[3];
        if (temp[4]) {
            duoUnitsLookUp[temp[4]] = temp[5];
        }
        return {
            ids: thisMeasureId,
            units: duoUnitsData,
            lookup: duoUnitsLookUp
        }

    }

    const dataPullDay = function () {
        return new Promise((resolve, reject) => {
            dataPull().then(response => {
                toggleLoadingMode('off');
                resolve(response);
            });
        });
    };


    // basic pull a data feed for a single ID from GE, send the results to processing. 
    // returns Promise.
    const dataPull = function (measureId, interval, startDate, endDate) {

        const thisMeasureId = measureId || defaultMeasureId;

        // if this measure id is actually several ids, redirect to the 
        // more complex multi-pull version
        if ((thisMeasureId + '').indexOf(',') >= 0) {
            return dataPullDuo(thisMeasureId, interval, startDate, endDate);
        }

        startDate = startDate || filterObj.date;
        endDate = endDate || filterObj.date;
        interval = interval || sources[mode].dataInterval || dataInterval;

        if (zoom) {
            if (longMode === 'year') {
                interval = 'day';
            } else {
                interval = 'hour';
            }
        }
        dataSegmentCount = (interval === 'hour' ? 24 : 144);
        //console.log( '%c%s', 'color:#FFDC00;background:#3e420e;padding:0.2em', 'PULLING DATA', 'id:', thisMeasureId, 'interval:', interval, 'start:', startDate, 'end:', endDate );

        const allowOriginIdParam = powerApiCors ? `&AllowOriginId=${powerApiCors}` : '';

        const fullUrl = `${powerApiUrl}${allowOriginIdParam}&MeasureId=${thisMeasureId}&StartDate=${startDate}&EndDate=${endDate}&Interval=${interval}`;

        return new Promise((resolve, reject) => {

            fetch(fullUrl)
                .then(response => response.json())
                .then(
                    response => {
                        if (response.status === 'Ok') {
                            resolve(response.result.measurements);
                        } else {
                            errorMode();
                            console.error('error pulling 24hr data. url: ' + fullUrl, response);
                            reject();
                        }
                    }
                )
                .catch(error => { console.error('FETCH Error:', fullUrl, error); toggleLoadingMode('off'); });
        });

    };

    // This is an alternate version of dataPull(), that aggregates asynchronous pulls of 
    // up to three data sources into a single one.
    // eg, whereas solevi is simply 96988, the gas one is '1757,kW,1701,MW' - which is parsed as 
    // two ids to query, along with the units they are in.
    // To keep it simple, we query each one in turn using promises, then add the results together.
    // returns Promise.
    const dataPullDuo = function (measureId, interval, startDate, endDate) {

        interval = interval || sources[mode].dataInterval || dataInterval;
        startDate = startDate || filterObj.date;
        endDate = endDate || filterObj.date;

        const idArrays = multiIdParse(measureId);
        const measureId0 = idArrays.ids[0];
        const measureId1 = idArrays.ids[1];
        const measureId2 = idArrays.ids[2];
        const unitsLookup = idArrays.lookup;

        //console.log( '%c%s', 'color:#FFDC00;background:#3e420e;padding:0.2em', 'PULLING DUO DATA', 'ids:', measureId, 'interval:', interval, 'start:', startDate, 'end:', endDate );

        const allowOriginIdParam = powerApiCors ? `&AllowOriginId=${powerApiCors}` : '';
        const fullUrl0 = `${powerApiUrl}${allowOriginIdParam}&MeasureId=${measureId0}&StartDate=${startDate}&EndDate=${endDate}&Interval=${interval}`;
        const fullUrl1 = `${powerApiUrl}${allowOriginIdParam}&MeasureId=${measureId1}&StartDate=${startDate}&EndDate=${endDate}&Interval=${interval}`;
        const fullUrl2 = `${powerApiUrl}${allowOriginIdParam}&MeasureId=${measureId2}&StartDate=${startDate}&EndDate=${endDate}&Interval=${interval}`;

        let data0 = null;
        let data1 = null;
        let data2 = null;

        return new Promise((resolve, reject) => {

            // fetch the first URL
            fetch(fullUrl0)
                .then(response => response.json())
                .then(
                    response => {
                        if (response.status === 'Ok') {
                            data0 = response.result.measurements;

                            if (!data0) {
                                data0 = [];
                            }

                            // fetch the second URL
                            fetch(fullUrl1)
                                .then(response => response.json())
                                .then(
                                    response => {
                                        if (response.status === 'Ok') {
                                            data1 = response.result.measurements;

                                            if (!data1) {
                                                data1 = [];
                                            }

                                            // if no third url
                                            if (!measureId2) {
                                                const dataOut = dataPullDuoProcess(data0, data1, false, unitsLookup);
                                                resolve(dataOut);
                                                return;
                                            }

                                            // fetch the third URL
                                            fetch(fullUrl2)
                                                .then(response => response.json())
                                                .then(
                                                    response => {
                                                        if (response.status === 'Ok') {
                                                            data2 = response.result.measurements;

                                                            if (!data2) {
                                                                data2 = [];
                                                            }

                                                            const dataOut = dataPullDuoProcess(data0, data1, data2, unitsLookup);

                                                            resolve(dataOut);

                                                        } else {
                                                            errorMode();
                                                            console.error('error pulling 24hr data2. url: ' + fullUrl2, response);
                                                            reject();
                                                        }
                                                    }
                                                )
                                                .catch(error => { console.error('Fetch Error:', fullUrl2, error); toggleLoadingMode('off'); });

                                        } else {
                                            errorMode();
                                            console.error('error pulling 24hr data1. url: ' + fullUrl1, response);
                                            reject();
                                        }
                                    }
                                )
                                .catch(error => { console.error('Fetch Error:', fullUrl1, error); toggleLoadingMode('off'); });

                        } else {
                            errorMode();
                            console.error('error pulling 24hr data0. url: ' + fullUrl0, response);
                            reject();
                        }
                    }
                )
                .catch(error => { console.error('Fetch Error:', fullUrl0, error); toggleLoadingMode('off'); });
        });

    };

    const dataPullDuoProcess = function (data0, data1, data2, unitsLookup) {

        // we need to add the timeslots together, baring in mind that either data set might be missing a value at any time slot. SO...
        // concat the arrays
        if (!data1) {
            data1 = [];
        }
        if (!data2) {
            data2 = [];
        }
        const data = data0.concat(data1, data2);

        // sort 
        function compare(a, b) {
            if (a.dateTime < b.dateTime) {
                return -1;
            }
            if (a.dateTime > b.dateTime) {
                return 1;
            }
            return 0;
        }
        data.sort(compare);
        // step thru
        const dataOut = [];
        let lastDateTime = null;
        data.forEach((row, i) => {
            // convert everything to kW
            let kwValue = (unitsLookup[row.measureId] === 'MW' ? row.value * 1000 : row.value);
            row.value = kwValue;
            // if this row is a multiple of the last row (eg, it's from data source 2), add to the row in data source 1
            if (row.dateTime === lastDateTime) {
                const temp1 = dataOut[dataOut.length - 1].value;
                dataOut[dataOut.length - 1].value += row.value;
                dataOut[dataOut.length - 1].values[row.measureId + ''] = row.value;
            } else {
                dataOut.push(row);
                dataOut[dataOut.length - 1].values = {};
                dataOut[dataOut.length - 1].values[row.measureId + ''] = row.value;
            }
            lastDateTime = row.dateTime;
        });
        // update unitsData so it's no longer array of two - possibly different - units. We've chosen kW.
        //unitsData = 'kW'; // NO!!! this then resets the global unit, so the 60second update of the tab data can unexpectedly change the figures in the today graph, showing kW but with MW labels.
        //console.log('dataOut',dataOut);

        return dataOut;

    }

    const dataDayProcess = function (data) {

        //console.log( '%c%s', 'color:#283815;background:#79ad3e;padding:1em', 'DATA', data );

        if (!data || !data.length) {
            errorMode();
            return;
        }

        // change EVERYTHING to kW, whether the data was provided in kW or MW

        let kwhTotal = 0;
        let kwCurrent = 0;
        let kwMax = 0;
        let kwhCurrent = 0;
        const latestIndex = Math.max(data.length - 1, 0);
        let latestReading = data[latestIndex];
        data.forEach((val, index) => {
            // cumulative total at current reading
            kwCurrent = (unitsData === 'MW' ? val.value * 1000 : val.value);                              // power - kw  
            kwhCurrent = kwCurrent * (24 / dataSegmentCount);
            kwhTotal += parseFloat(kwhCurrent);
            data[index].kwh = kwhCurrent;
            data[index].cumulative = kwhTotal;
            if (kwCurrent > kwMax) {
                kwMax = kwCurrent;
            }
        });

        // change the units displayed in the hub dynamically, depending on the max output.
        if (kwMax > 6000) {
            unitsHub = 'MW';
        } else {
            unitsHub = 'kW';
        }

        setData(data);
        dataMaxkW = d3.max(data, function (d) { return d.value; });

        // NEXT API CALL
        const nextCallIn = new Date(tickDate.getTime() + dayUpdate * 1000);
        const payloadAPICall = {
            id: 'powerAPI',
            status: 'waiting',
            type: 'api',
            lastDate: parseUTC(latestReading.dateTime),
            nextDate: nextCallIn, // pull again in 60 seconds
            callback: updateCycle
        };
        updateTickerSubscription(payloadAPICall);

        //console.log('%c%s', 'color:#80C4CE;background:#0e3f42;padding:0.2em', 'DATA', 'kwhTotal', kwhTotal, 'kwhPrev', data[Math.max(data.length - 2, 0)].cumulative, 'kwhCurrent', kwhCurrent, 'kwCurrent', kwCurrent, latestReading.dateTime); // kwH TOTAL VALUE

        // kwH TOTAL VALUE
        // note that if it's today, we step 1 cumulative reading back (index - 2) to not overinflate the value as it counts up.
        // if it's for a previous day, we return to the last cumulative reading (index - 1)
        const readingPrevKwh = data[Math.max(data.length - (isToday(filterObj.date) ? 2 : 1), 0)].cumulative;
        const readingPrevXwh = (unitsHub === 'MW' ? readingPrevKwh / 1000 : readingPrevKwh);

        const payloadValue1 = {
            id: 'kwhTotal',
            status: 'constant',
            type: 'numberInterpolate',
            $el: $hudHubValue1,
            readingTime: parseUTC(latestReading.dateTime),
            readingNumber: readingPrevXwh,
            timePerSegment: (24 / dataSegmentCount) * 1000 * 60 * 60,
            diffPerSegment: (unitsHub === 'MW' ? kwhCurrent / 1000 : kwhCurrent),
            decimal: (readingPrevXwh < 10000 ? 2 : 1)
        };
        updateTickerSubscription(payloadValue1);

        // kw CURRENT/MAX VALUE
        let readingXw = (unitsHub === 'MW' ? kwCurrent / 1000 : kwCurrent);
        if (!isToday(filterObj.date)) {
            readingXw = (unitsHub === 'MW' ? kwMax / 1000 : kwMax);
        }
        const payloadValue2 = {
            id: 'kwCurrent',
            status: 'constant',
            type: 'numberSimple',
            $el: $hudHubValue2,
            readingTime: tickDate,
            readingNumber: readingXw,
            decimal: (readingXw < 10 ? 1 : 0),
            decimalBreakPoint: (readingXw < 10 ? 10 : false)
        };
        setTimeout(() => {
            updateTickerSubscription(payloadValue2);
        }, 100);

        // MAX % CURRENT/MAX VALUE
        let percentageEfficiency = Math.round((kwCurrent * 100) / (unitsData === 'MW' ? optimumMax * 1000 : optimumMax));
        if (!isToday(filterObj.date)) {
            percentageEfficiency = Math.round((kwMax * 100) / (unitsData === 'MW' ? optimumMax * 1000 : optimumMax));
        }
        const payloadValue3 = {
            id: 'kwPercent',
            status: 'constant',
            type: 'numberSimple',
            $el: $hudHubValue3,
            readingTime: tickDate,
            readingNumber: percentageEfficiency,
            suffix: '%'
        };
        setTimeout(() => {
            updateTickerSubscription(payloadValue3);
        }, 500);

        // update the UI
        updateUI();
        toggleLoadingMode('off');

    };

    let graphRadialD3 = null;
    const drawRadialGraph = function () {

        if (!dataObj || !dataObj.length) {
            errorMode();
            return;
        }

        const radiusMax = radius40 - 30;
        const dataIntervalThis = sources[mode].dataInterval || dataInterval;

        if (dataIntervalThis === 'hour') {
            dataSegmentCount = 24;
        } else {
            dataSegmentCount = 144;
        }
        // create an array of slots during sun-up-down
        const hours = sunDownHour - sunUpHour;
        let radialArray = d3.range(sunUpHour, sunDownHour, hours / ((hours / 24) * dataSegmentCount));

        // create an "empty" data array of all the slots in the sun-up-down period
        const sunnyDataObj = [];
        radialArray.forEach(val => {
            const hour = (parseInt(val) + '').padStart(2, '0');
            let mins = Math.round((val - hour) * 60);
            mins = (mins + '').padStart(2, '0');
            sunnyDataObj.push({
                dateTime: filterObj.date + 'T' + hour + ':' + mins + ':00',
                value: 0
            })
        })

        // back to that list of slots, we now round the figures to 3 figures so we can easily compare them later.
        let radialArrayClone = JSON.parse(JSON.stringify(radialArray));
        radialArray = radialArrayClone.map((val) => {
            return Math.round(val * 1000) / 1000;
        });

        // step through the real data and put into sunnyDataObj (so the data is for the whole day, not just "so far" today).
        // note that we use radialArray as a look up for the index of data to update in sunnyDataObj
        dataObj.forEach((val, index) => {
            const valDateTime = parseUTC(val.dateTime);
            const hoursInDecimal = Math.round((valDateTime.getHours() + (valDateTime.getMinutes() / 60)) * 1000) / 1000;
            if (val.value && val.value > 0) {
                if (sunnyDataObj[radialArray.indexOf(hoursInDecimal)]) {
                    sunnyDataObj[radialArray.indexOf(hoursInDecimal)].value = val.value;
                    if (!val.values) {
                        sunnyDataObj[radialArray.indexOf(hoursInDecimal)][sources[mode].id] = val.value;
                    } else {
                        sunnyDataObj[radialArray.indexOf(hoursInDecimal)].values = val.values;
                        Object.keys(val.values).forEach((key) => {
                            sunnyDataObj[radialArray.indexOf(hoursInDecimal)][key] = val.values[key];
                        });
                    }
                }
            }
        });

        // stacking the radial graph
        const stackKeys = multiIdParse(sources[mode].id).ids;
        const stack = d3.stack()
            .keys(stackKeys)
            .order(d3.stackOrderNone)
            .offset(d3.stackOffsetNone);
        const sunnyDataLayers = stack(sunnyDataObj);

        // add the index of each stack to each child (for lookups later)
        sunnyDataLayers.forEach((d, i) => {
            d.forEach((e, k) => { sunnyDataLayers[i][k].index = i });
        });

        // convert the time array back into ISO dates
        radialArrayClone = JSON.parse(JSON.stringify(radialArray));
        radialArray = radialArrayClone.map((val) => {
            const thisHour = (parseInt(val) + '').padStart(2, '0');
            let thisMinutes = Math.round((val - thisHour) * 60)
            thisMinutes = (thisMinutes + '').padStart(2, '0');
            return `${dateToISO(dataDate)}T${thisHour}:${thisMinutes}:00`;
        });

        // set the limits of the graph
        let maxKwPerRow = 0;
        optimumMax = (optimumMax ? parseInt(optimumMax) : 0);
        if (zoom || (optimumMax && dataMaxkW > (optimumMax * 0.8))) {      // if the actual kW is within 20% of the max, size the graph by the stated max
            maxKwPerRow = optimumMax;
        } else {
            maxKwPerRow = dataMaxkW + (optimumMax * 0.05);
        }

        // D3 sizing/positioning methods
        const x = d3.scaleBand()
            .domain(radialArray.map(d => d))
            .range([Math.radians(sweepAngleStart), Math.radians(sweepAngleEnd)])
            .align(0);

        const y = d3.scaleLinear()
            .domain([0, maxKwPerRow || 1])
            .range([radius10, radiusMax]);
        const arc = d3.arc()
            .innerRadius(d => y(d[0]))
            .outerRadius(d => y(d[1]))
            .startAngle(d => x(d.data.dateTime))
            .endAngle(d => { return x(d.data.dateTime) + x.bandwidth(); })
            .padAngle(0.005)
            .padRadius(radius10);

        // const yClamped = d3.scaleLinear()
        //     .domain([ 0, maxKwPerRow || 1 ])
        //     .range( [radius10, radiusMax] )
        //     .clamp(true);

        // const arcClamped = d3.arc()
        //     .innerRadius( d => yClamped( d[0] ) )
        //     .outerRadius( d => yClamped( d[1] ) )
        //     .startAngle( d => x( d.data.dateTime ) )
        //     .endAngle( d => { return x( d.data.dateTime ) + x.bandwidth(); } )
        //     .padAngle( 0.005 )
        //     .padRadius( radius10 );

        // TEMP - FIND BETTER WAYY!!!
        $svg1ClockGraph.selectAll('.hud__clockgraph__grp').remove();

        graphRadialD3 = $svg1ClockGraph
            .selectAll('.hud__clockgraph__grp')
            .data(sunnyDataLayers, (d, i) => i)
            .enter()
            .append('g')
            .attr('class', (d, i) => 'hud__clockgraph__grp--' + (sourcesMeta[stackKeys[i] + ''] ? sourcesMeta[stackKeys[i] + ''].class : mode))
            .classed('hud__clockgraph__grp', true)
            .attr('data-source', (d, i) => stackKeys[i]);

        // graphRadialD3
        //     .selectAll( '.hud__clockgraph__extended' )
        //     .data( function(d) { return d; } )
        //     .enter()
        //         .append( 'path' )
        //         .attr( 'class', ( d, i ) => 'hud__clockgraph__slice--' + ( sourcesMeta[ stackKeys[ d.index ] + '' ] ? sourcesMeta[ stackKeys[ d.index ] + '' ].class : 'none' ) )
        //         .classed( 'hud__clockgraph__extended', true )
        //         .classed( 'hud__has-tooltip', true )
        //         .attr( 'mask', 'url(#extendedMask)' )
        //         .attr( 'data-extended-source', d => stackKeys[ d.index ] )
        //         .attr( 'data-extended-parent', d => d.index )
        //         .attr( 'data-extended-index', ( d, i ) => i )
        //         .attr( 'data-extended-time', d => d.data.dateTime )
        //         .attr( 'data-extended-value', d => d.data[ stackKeys[ d.index ] ] )
        //         .attr( 'data-js-tooltip', ( d, i ) => 'slice' + i )
        //         .attr( 'data-tooltip-text', d => { return 'kl ' + d.data.dateTime.substr(11,5) + ( sourcesMeta[ stackKeys[ d.index ] + '' ] ? '\n' + sourcesMeta[ stackKeys[ d.index ] + '' ].suffix + ' ' + sourcesMeta[ stackKeys[ d.index ] + '' ].type : '' ) + "\n" + d.data.value.toFixed(1) + unitsData + ( !optimumMaxHide? "\n" + Math.round( (d.data[ stackKeys[ d.index ] ]*100)/optimumMax ) + '%' : '' ) } )
        //         .transition()
        //             .duration( 1000 )
        //             //.delay( function( d, i ) { return i * 25;} )
        //             .attr( 'd', arc );

        // build the radial graph
        graphRadialD3
            .selectAll('.hud__clockgraph__slice')
            .data(function (d) { return d; })
            .enter()
            .append('path')
            .attr('class', (d, i) => 'hud__clockgraph__slice--' + (sourcesMeta[stackKeys[d.index] + ''] ? sourcesMeta[stackKeys[d.index] + ''].class : mode))
            .classed('hud__clockgraph__slice', true)
            .classed('hud__has-tooltip', true)
            .attr('mask', 'url(#extendedMask)')
            .attr('data-source', d => stackKeys[d.index])
            .attr('data-parent', d => d.index)
            .attr('data-index', (d, i) => i)
            // .attr( 'data-val-inner', d => d[0] )
            // .attr( 'data-val-outer', d => d[1] )
            // .attr( 'data-radius-inner', d => y( d[0] ) )
            // .attr( 'data-radius-outer', d => y( d[1] ) )
            .attr('data-time', d => d.data.dateTime)
            .attr('data-value', d => d[1] - d[0])
            .attr('data-js-tooltip', (d, i) => 'slice' + i + ':' + stackKeys[d.index])
            .attr('data-tooltip-text', d => {
                const source = sourcesMeta[stackKeys[d.index] + '']
                const maxValue = source && source.max ? source.max : optimumMax
                return 'kl ' + d.data.dateTime.substr(11, 5) +
                    (source ? '\n' + source.type + ' ' + source.suffix : '') + "\n" +
                    unitsOut(unitsData, d[1] - d[0], 1).value +
                    unitsOut(unitsData, d[1] - d[0]).units +
                    (!optimumMaxHide
                        ? "\n" + Math.round((d.data[stackKeys[d.index]] * 100) / maxValue) + '%'
                        : '')
            }
            )
            .transition()
            .duration(1000)
            //.delay( function( d, i ) { return i * 25;} )
            .attr('d', arc);

        graphRadialD3
            .exit()
            .remove();

    };


    //
    // TAB (CURRENT PERF) INFO
    //

    const dataPullTabs = function () {

        for (const sourceKey in sources) {

            const source = sources[sourceKey];

            if (source.hideTab) {
                continue;
            }

            const measureId = source.id;


            dataPull(measureId, 'current').then(response => {


                let mW = response[0].value;

                // convert kW to MW
                if (source.unitsData === 'kW') {
                    mW = mW / 1000;
                }
                // decimal small numbers
                if (parseInt(mW) < 10) {
                    mW = (mW).toFixed(1);
                } else {
                    mW = Math.round(mW);
                }
                // print total value
                if (source)
                    document.querySelector('[data-tab="' + sourceKey + '"]').innerText = mW + 'MW';
                // adjust mini bar graph
                //let graphMax = 1000;
                //const graphPerc = Math.round( ( mW/graphMax ) * 100 );
                //document.querySelector('[data-js-tab-graph="' + sourceKey + '"]').style.height = Math.min( graphPerc, 100 ) + '%
            });
        };

        // NEXT API CALL
        const nextCallIn = new Date(tickDate.getTime() + tabUpdate * 1000);
        const payloadAPICall = {
            id: 'tabsAPI',
            status: 'waiting',
            type: 'api',
            nextDate: nextCallIn, // pull again in 60 seconds
            callback: dataPullTabs
        };
        updateTickerSubscription(payloadAPICall);

    };


    //
    // LONG TERM BAR GRAPH
    //

    const dataLongPull = function () {

        //console.log( '%c%s', 'color:#FFDC00;background:#3e420e;padding:0.2em', 'PULLING TIMELINE DATA', new Date() );

        const measureId = defaultMeasureId;

        let startDate = filterObj.date;
        let endDate = filterObj.date;
        let interval = null;

        // calc start/end dates
        if (longMode === '30days') {
            if (isToday(endDate)) {
                const startDateObj = parseUTC(endDate);
                startDate = dateToISO(startDateObj.addDays(-30));
            } else {
                // attempt to find 15 days in the future (placing the current day in the middle of the set)
                const midDateObj = parseUTC(endDate);
                let endDateObj = midDateObj.addDays(15);
                if (endDateObj > new Date()) {
                    endDateObj = new Date();
                }
                endDate = dateToISO(endDateObj);
                startDate = dateToISO(endDateObj.addDays(-30));
            }
            interval = 'hour';
        } else if (longMode === 'year') {
            if (isToday(endDate)) {
                const startDateObj = parseUTC(endDate);
                startDate = dateToISO(startDateObj.addDays(-365));
            } else {
                // attempt to find 15 days in the future (placing the current day in the middle of the set)
                const midDateObj = parseUTC(endDate);
                let endDateObj = midDateObj.addDays(15);
                if (endDateObj > new Date()) {
                    endDateObj = new Date();
                }
                endDate = dateToISO(endDateObj);
                startDate = dateToISO(endDateObj.addDays(-365));
            }
            interval = 'day';
        }

        // pull hourly data

        toggleLoadingMode('on');
        dataPull(false, interval, startDate, endDate).then(response => {

            const data = dataLongProcess(response, startDate, endDate, interval);
            longDataObj[0] = data;

            dataLongClear(true);
            d3LongAxis(data, startDate, endDate, interval);
            d3LongGraph(data, startDate, endDate, interval);
            updateUI();
            toggleLoadingMode('off');


            // pull daily data (do even if we are pulling hourly daya - it's used in the pop-over)
            dataPull(false, 'day', startDate, endDate).then(response => {
                const data = dataLongProcess(response, startDate, endDate, 'day');
                longDataObj[1] = data;
            });

            dataLongPullSecondary(startDate, endDate);
            toggleLoadingMode('off');
        });


    };

    let graphBackD3 = null;
    const d3LongAxis = function (data, startDate, endDate, interval) {

        const dateDayLookup = ['sön', 'mån', 'tis', 'ons', 'tor', 'fre', 'lör'];
        const dateMonthLookup = ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];
        let days = 30;
        if (longMode === 'year') {
            days = 365;
        }

        const scale = d3.scaleTime()
            .domain([parseUTC(startDate), parseUTC(endDate, -1)])
            .range([0, graphWidth]);

        const xAxis = d3.axisBottom(scale)
            .ticks((longMode === 'year' ? d3.timeMonth.every(1) : d3.timeDay.every(1)))
            .tickFormat(function (d) {
                if (longMode === 'year') {
                    return dateMonthLookup[d.getMonth()] + ' ' + d3.timeFormat("%Y")(d);
                } else {
                    return dateDayLookup[d3.timeFormat("%w")(d)] + ' ' + d3.timeFormat("%e")(d) + ' ' + dateMonthLookup[d.getMonth()];
                }
            });

        const xDays = scale.ticks(d3.timeDay.every(1));
        const scaleBand = graphWidth / (xDays.length - 1);

        $svg1LongGraphBack
            .append('g')
            .classed('hud__longgraph__xgrid__g', true)
            .selectAll('rect')
            .data(xDays)
            .enter()
            .append('rect')
            .attr('x', (d, i) => { return (i * scaleBand) })
            .attr('y', 0)
            .attr('width', graphWidth / days)
            .attr('height', graphHeight)
            .classed('hud__longgraph__xgrid__rect', true)
            .classed('hud__longgraph__xgrid__rect--wkend', d => { return ([0, 6].indexOf(d.getDay()) >= 0 ? true : false) })

            .classed('hud__has-tooltip', true)
            .attr('data-js-tooltip', (d, i) => 'slice' + i)
            .attr('data-js-tooltip2', (d, i) => 'slice' + i)
            .attr('data-tooltip-text', d => {
                return dateDayLookup[d3.timeFormat("%w")(d)] + ' ' + d3.timeFormat("%Y")(d) + '-' + d3.timeFormat("%m")(d) + '-' + d3.timeFormat("%d")(d);
            })
            .attr('data-tooltip-long-data', (d, i) => i)

            .on('click', d => {
                goToDay(d3.timeFormat("%Y")(d) + '-' + d3.timeFormat("%m")(d) + '-' + d3.timeFormat("%d")(d));
            });

        // the bottom X axis
        $svg1LongGraphAxis
            .append("g")
            .classed('hud__longgraph__xaxis__g', true)
            .attr("transform", `translate( 0 ${graph1Bot} )`)
            .call(xAxis)
            .selectAll("text")
            .attr('transform', (isChrome() ? 'rotate( 90 10 6 )' : 'rotate( 90 11 19 )'));
    };

    let graphLongD3 = null;
    const d3LongGraph = function (data) {

        const max = d3.max(data, function (d) { return d.value; });


        // STACKING
        const stackKeys = multiIdParse(sources[mode].id).ids;
        const stack = d3.stack()
            .keys(stackKeys)
            .order(d3.stackOrderNone)
            .offset(d3.stackOffsetNone);
        const dataLayers = stack(data);

        // add the index of each stack to each child (for lookups later)
        dataLayers.forEach((d, i) => {
            d.forEach((e, k) => {
                dataLayers[i][k].index = i
            }
            );
        });

        const x = d3.scaleBand()
            .domain(data.map(d => d.dateTime))
            .padding(0)
            .range([0, graphWidth])

        const y = d3.scaleLinear()
            .domain([0, max])
            .range([graph1Bot, graph1Top]);

        graphLongD3 = $svg1LongGraph
            .append("g")
            .classed('hud__longgraph__slices', true)
            .selectAll('.hud__longgraph__slices__grp')
            .data(dataLayers, (d, i) => i)
            .enter()
            .append('g')
            .attr('class', (d, i) => 'hud__longgraph__slices__grp--' + (sourcesMeta[stackKeys[i] + ''] ? sourcesMeta[stackKeys[i] + ''].class : 'none'))
            .classed('hud__longgraph__slices__grp', true)
            .attr('data-source', (d, i) => stackKeys[i]);

        graphLongD3
            .selectAll('rect')
            .data(function (d) { return d; })
            .enter()
            .append('rect')
            .attr('class', (d, i) => 'hud__longgraph__slice--' + (sourcesMeta[stackKeys[d.index] + ''] ? sourcesMeta[stackKeys[d.index] + ''].class : 'none'))
            .classed('hud__longgraph__slice', true)
            .classed('hud__longgraph__slice--odd', d => { const dateObj = new Date(d.data.dateTime); const num = d3.timeFormat("%y")(dateObj) + d3.timeFormat("%j")(dateObj); return num % 2; })
            .attr("x", d => x(d.data.dateTime))
            .attr("y", d => y(d[1]))
            .attr('height', d => (isNaN(d[1]) ? 0 : y(d[0]) - y(d[1])))
            .attr("width", x.bandwidth())

            .attr('data-source', d => stackKeys[d.index])
            .attr('data-index', (d, i) => i)
            .attr('data-time', d => d.data.dateTime)
            .attr('data-value', d => d.data[stackKeys[d.index]]);

        graphLongD3
            .exit()
            .remove();

        addClass(document.querySelector('.hud__longgraph'), 'hud__longgraph--active');


    }


    //
    // LONG TERM - SECONDARY LINE GRAPH(S)
    //

    const dataLongPullSecondary = function (startDate, endDate) {

        const secondarySources = sources[mode].secondary;
        if (secondarySources) {

            secondarySources.forEach((source, i) => {

                const apiTitle = source.title;
                const measureId = source.id;

                dataPull(measureId, 'day', startDate, endDate).then(response => {
                    secondDataObj[i] = response;
                    dataLongProcessSecondary(i);

                });

            });

        }

    };

    const dataLongProcessSecondary = function (slot) {

        // wrong number of data points - this needs fixing as it kills the partial data from today, but it's a quick fix to align the line graph with the bar graph.
        const data = secondDataObj[0];
        data.pop();
        const sourceConfig = sources[mode].secondary[slot];
        const max = d3.max(data, function (d) { return d.value; });
        const min = d3.min(data, function (d) { return d.value; });
        const graphTop = (slot === 0 ? graph2Top : graph3Top);
        const graphBot = (slot === 0 ? graph2Bot : graph3Bot);

        const $domLineGraph = d3.select($inner).select('#hud-longgraph-line' + slot);
        const $domLineTitle = d3.select($inner).select('#hud-longgraph-line' + slot + '-title');

        // title
        $domLineTitle
            .append("text")
            .text(sourceConfig.title);

        const scaleX = d3.scaleLinear()
            .domain([0, data.length])
            .range([0, graphWidth]);

        const scaleY = d3.scaleLinear()
            .domain([min, max])
            .range([graphBot - graphTop, 1]);

        const line = d3.line()
            .curve(d3.curveNatural) // d3.curveLinear
            .x((d, i) => { return scaleX(i + 1) - (graphWidth / data.length) / 2; })
            .y((d) => { return scaleY(d.value); });

        $domLineGraph
            .append("path")
            .classed('hud__longgraph__line', true)
            .datum(data)
            .attr("fill", "none")
            .attr("d", line)
            .attr('data-title', sourceConfig.title)

        // dot labels
        let minSet = false;
        let maxSet = false;
        $domLineGraph
            .append("g")
            .classed('hud__longgraph__line__labels', true)
            .selectAll(".hud__longgraph__line__label")
            .data(data)
            .enter()
            .append('text')
            .attr("x", (d, i) => { return (i / data.length * graphWidth) + (graphWidth / data.length / 2) })
            .attr("y", (d) => { return scaleY(d.value); })
            .attr("dy", (d, i) => {
                if (!minSet && ((min && d.value === min) || !min && i === 0)) {
                    minSet = true;
                    return "1.8em";
                } else if (!maxSet && max && d.value === max) {
                    maxSet = true;
                    return "-0.8em";
                }
            })
            .attr("text-anchor", "middle")
            .classed('hud__longgraph__line__label', true)
            .text((d, i) => {
                if ((min && d.value === min) || !min && i === 0) {
                    return d.value.toFixed(2) + sourceConfig.unitsData;
                } else if (d.value === max && max !== 0) {
                    return d.value.toFixed(2) + sourceConfig.unitsData;
                }
            });

        // dots
        // $domLineGraph
        //     .append("g")
        //     .classed('hud__longgraph__line__dots', true)
        //     .selectAll(".hud__longgraph__line__dot")
        //     .data( data )
        //         .enter()
        //         .append( 'circle' )
        //         .classed( 'hud__longgraph__line__dot', true )
        //         .attr( 'cx', (d, i) => { return scaleX( i ) + ( graphWidth/data.length ) / 2; } )
        //         .attr( 'cy', (d) => { return scaleY( d.value ); } )
        //         .attr( 'r', (d) => { return ( d.value ? 3 : 0 ); } )
        //         .attr( 'data-type', d => d.value )

    };

    const dataLongProcess = function (data, startDate, endDate, interval) {

        // create a base array of available slots ("full" data array)
        const days = Math.round((parseUTC(endDate) - parseUTC(startDate)) / (1000 * 60 * 60 * 24));
        const emptyArray = new Array(days * (interval === 'hour' ? 24 : 1)).fill(0);
        const additional = 1000 * 60 * 60 * (interval === 'hour' ? 1 : 24);
        const startDateTime = parseUTC(startDate).getTime();
        let fullData = [];
        let fullLookup = {};
        emptyArray.forEach((d, i) => {
            const newDateTime = new Date(startDateTime + (i * additional));
            let newDateISO = null;

            if (longMode === 'year' || interval === 'day') {
                newDateISO = dateToISO(newDateTime) + 'T00:00:00';
            } else {
                newDateISO = dateToISO(newDateTime, true);
            }
            fullData.push({
                dateTime: newDateISO,
                value: 0
            });
            fullLookup[newDateISO] = fullData.length - 1;
        });
        // loop through the data and put it into the full data array
        data.forEach((d, i) => {
            if (d.value > 0) {
                try {
                    fullData[fullLookup[d.dateTime]].value = d.value;
                    if (!d.values) {
                        fullData[fullLookup[d.dateTime]][sources[mode].id] = d.value;
                    } else {
                        fullData[fullLookup[d.dateTime]].values = d.values;
                        Object.keys(d.values).forEach((key) => {
                            fullData[fullLookup[d.dateTime]][key] = d.values[key];
                        });
                    }
                } catch {
                    console.log('dataLongProcess', 'failed to find slot');
                }
            }
        });

        return fullData;

    };

    const dataLongClear = function (andAxis) {

        $svg1LongGraph.selectAll('.hud__longgraph__slices').remove();
        $svg1LongGraphLine1.selectAll('.hud__longgraph__line').remove();
        $svg1LongGraphLine1Title.selectAll('text').remove();
        $svg1LongGraphLine1.selectAll('.hud__longgraph__line__dots').remove();
        $svg1LongGraphLine1.selectAll('.hud__longgraph__line__labels').remove();
        $svg1LongGraphLine2.selectAll('.hud__longgraph__line').remove();
        $svg1LongGraphLine2Title.selectAll('text').remove();
        $svg1LongGraphLine2.selectAll('.hud__longgraph__line__dots').remove();
        $svg1LongGraphLine2.selectAll('.hud__longgraph__line__labels').remove();
        if (andAxis) {
            $svg1LongGraphBack.selectAll('.hud__longgraph__xgrid__g').remove();
            $svg1LongGraphAxis.selectAll('.hud__longgraph__xaxis__g').remove();
        }


    };

    const setData = function (data) {
        dataObj = data;
    };

    const isToday = function (td) {
        if (!(td instanceof Date)) {
            td = new Date(td);
        }
        var d = new Date();
        return (td.getDate() == d.getDate() && td.getMonth() == d.getMonth() && td.getFullYear() == d.getFullYear());
    };

    const dateToISO = function (dateObj, time) {
        if (time) {
            return dateObj.getFullYear() + '-' + ((dateObj.getMonth() + 1) + '').padStart(2, '0') + '-' + (dateObj.getDate() + '').padStart(2, '0') + 'T' + (dateObj.getHours() + '').padStart(2, '0') + ':' + (dateObj.getMinutes() + '').padStart(2, '0') + ':00';
        } else {
            return dateObj.getFullYear() + '-' + ((dateObj.getMonth() + 1) + '').padStart(2, '0') + '-' + (dateObj.getDate() + '').padStart(2, '0');
        }
    }

    const setHour = function (val) {
        currentHour = val;
        return currentHour;
    };

    const dataLongScrollObserver = function () {
        const options = {
            root: document.querySelector('[data-js-longgraph-track]')
        }
        const observer = new IntersectionObserver((entries) => {
            // quick exit if not in calendar mode
            if (!zoom) {
                return;
            }
            entries.forEach(entry => {
                let $elem = entry.target;
                const direction = $elem.getAttribute('data-js-longgraph-stop');
                if (entry.isIntersecting && entry.intersectionRatio > 0.1) {
                    dataLongClearShadow(direction);
                } else {
                    dataLongShowShadow(direction);
                }
            });
        }, options);
        const targets = document.querySelectorAll('[data-js-longgraph-stop]');
        for (let i = 0; i < targets.length; i++) {
            observer.observe(targets[i]);
        };
    };

    const dataLongShowShadow = function (rightLeft) {
        //console.log( 'dataLongShowShadow',rightLeft )
        if (!rightLeft) {
            return;
        }
        const $shadow = document.querySelector('[data-js-longgraph-shadow-' + rightLeft + ']');
        addClass($shadow, 'hud__longgraph__shadow--active');
    };

    const dataLongClearShadow = function (rightLeft) {
        if (!rightLeft) {
            return;
        }
        const $shadow = document.querySelector('[data-js-longgraph-shadow-' + rightLeft + ']');
        removeClass($shadow, 'hud__longgraph__shadow--active');
    };

    function parseUTC(s) {
        if (!s) {
            return new Date();
        }
        if (s.indexOf(':') < 0) {
            s += 'T00:00:00';
        }
        var b = s.replace(/:/g, '|').replace(/-/g, '|').replace(/T/g, '|').split('|'); // changed from a regexp replace, because babel transpiling. Ugh.
        return new Date(b[0], --b[1], b[2], b[3], b[4], b[5]);
    };

    function checkForFullscreen() {
        if ($inner.requestFullscreen) {
            $canvas.classList.add('hud--fullscreen-capable');
        }
    };

    function toggleFullScreen() {
        if (!document.fullscreenElement) {
            $inner.requestFullscreen().then(() => {
                checkFullScreen();
            });
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
                checkFullScreen();
            }
        }
    };

    function checkFullScreen() {
        if (document.fullscreenElement) {
            $inner.classList.add('hud--fullscreen-active');
        } else {
            $inner.classList.remove('hud--fullscreen-active');
        }
    }

    function addClass($el, classId) {
        if (!$el) {
            return;
        }
        if ($el.getAttribute('class').indexOf(classId.substr(1)) < 0) {
            $el.setAttribute('class', ($el.getAttribute('class') + ' ' + classId).replace(/  /g, ' '));
        }
    };
    function removeClass($el, classId) {
        if (!$el) {
            return;
        }
        let allDone = false;
        while (!allDone) {
            if ($el.getAttribute('class').indexOf(classId.substr(1)) >= 0) {
                $el.setAttribute('class', $el.getAttribute('class').replace(new RegExp('(^|\\b)' + classId.split(' ').join('|') + '(\\b|$)', 'gi'), ' ').replace(/  /g, ' '));
            } else {
                allDone = true;
            }
        }
    };

    function isSafari() {
        return (navigator.userAgent.indexOf("Safari") >= 0 && navigator.userAgent.indexOf("Chrome") < 0) || navigator.userAgent.indexOf("iPad") > 0 || navigator.userAgent.indexOf("iPhone") > 0;
    }
    function isChrome() {
        return (navigator.userAgent.indexOf("Safari") >= 0 && navigator.userAgent.indexOf("Chrome") >= 0);
    }
    function isIE() {
        return (navigator.userAgent.indexOf("rv:11.0") >= 0);
    }

    /*getWeek() was developed by Nick Baicoianu at MeanFreePath: http://www.meanfreepath.com */
    Date.prototype.getWeek = function (dowOffset) {

        dowOffset = typeof (dowOffset) == 'int' ? dowOffset : 0; //default dowOffset to zero
        var newYear = new Date(this.getFullYear(), 0, 1);
        var day = newYear.getDay() - dowOffset; //the day of week the year begins on
        day = (day >= 0 ? day : day + 7);
        var daynum = Math.floor((this.getTime() - newYear.getTime() -
            (this.getTimezoneOffset() - newYear.getTimezoneOffset()) * 60000) / 86400000) + 1;
        var weeknum;
        //if the year starts before the middle of a week
        if (day < 4) {
            weeknum = Math.floor((daynum + day - 1) / 7) + 1;
            if (weeknum > 52) {
                var nYear = new Date(this.getFullYear() + 1, 0, 1);
                var nday = nYear.getDay() - dowOffset;
                nday = nday >= 0 ? nday : nday + 7;
                /*if the next year starts before the middle of
                    the week, it is week #1 of that year*/
                weeknum = nday < 4 ? 1 : 53;
            }
        }
        else {
            weeknum = Math.floor((daynum + day - 1) / 7);
        }
        return weeknum;
    };

    Date.prototype.addDays = function (days) {
        const date = new Date(this.valueOf());
        const newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate() + days); // much better than setDate(date.getDate() + days), as it takes advantage of autocorrect in all modern js engines, eg new Date(2018,06,-1) will corrcetly give 2018-05-31.
        //console.log('addDays',date,' =>',newDate)
        return newDate;
    };

    Math.radians = function (degrees) {
        return degrees * Math.PI / 180;
    };
    Math.degrees = function (radians) {
        return radians * 180 / Math.PI;
    };

    if (!Element.prototype.matches) {
        Element.prototype.matches = Element.prototype.msMatchesSelector ||
            Element.prototype.webkitMatchesSelector;
    }

    if (!Element.prototype.closest) {
        Element.prototype.closest = function (s) {
            var el = this;

            do {
                if (el.matches(s)) return el;
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null; n
        };
    }

    return {
        init: init(),
        setHour
    };

};
// if page already loaded (depends on script position)
if (document.readyState === "complete" || document.readyState === "loaded") {
    effektDashboard();
}
// if page not yet loaded (depends on script position)
document.addEventListener("DOMContentLoaded", function () {
    effektDashboard();
});